import React, { Component } from "react";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  getSingleForm,
  getAllSubmissionTotals,
  getTotalFormSubmissions,
  sendFormEmail,
  viewGeneralSubmission,
  deleteGeneralSubmission,
  assignForm,
  getClientSubmissions,
  getAgentSubmissions,
  viewClientSubmission,
  viewAgentSubmission,
  resendGeneralForm,
  rejectGeneralSubmission,
  approveGeneralSubmission,
  allGeneralRejections,
  approveClientSubmission,
  rejectClientSubmission,
  allClientRejections,
  deleteSubmissionForm,
  getClientArchivedForms,
  getAgentArchivedForms,
  getGeneralArchivedForms,
  getSubmissionLink,
  getNotificationSettings,
  submitNotificationSettings,
} from "./../../../config/forms_api_calls";
import {
  listActiveClients,
  listSingleClient,
} from "./../../../config/reseller_api_calls";
import {
  getSupplierSubmissions,
  viewSupplierSubmission,
  getSuppliersArchivedForms,
} from "./../../../config/general_api_calls";
import {
  listAgents,
  sendSubmissionLinkByEmail,
  sendPartnerSubmissionLinkByEmail,
  sendSupplierSubmissionLinkByEmail,
} from "./../../../config/api_calls";
import { getClientMenuActiveGroups } from "./../../../config/client_role_api_calls";
import $ from "jquery";
import {
  AGENT_PORTAL_URL,
  APP_LIVE_URL,
  APP_URL,
} from "../../../config/config";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import FormRenderer from "../../../components/Reseller/formRender";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import MutextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import localization from "../../../localization/enUS";
import { ValidateEmail } from "../../../config/utility";
const animatedComponents = makeAnimated();

const auth = new HelperClass();

class Forms extends Component {
  constructor() {
    super();

    this.state = {
      errorMessage: "",
      successMessage: "",
      successMessaged: "",
      errorMessaged: "",
      errorMessageTotals: "",
      errorMessageTotalsTitle: "",
      errorMessageClients: "",
      errorMessageClientsTitle: "",
      errorMessageAgents: "",
      errorMessageAgentsTitle: "",
      emailErrorMessage: "",
      emailErrorMessageTitle: "",
      emailSuccessMessage: "",
      errorMessageDelete: "",
      successMessageDelte: "",
      mainError: "",
      tableLoader: true,
      disabled: false,
      form_accountno: "",
      form_title: "",
      form_desc: "",
      form_status: "",
      form_content: [],
      showOnDashboard: false,
      form_sequence: "1",
      form_sequence_error: "",
      btn_text: "",
      allow_multiple: false,
      is_default: false,
      activeTab: "total_submissions",
      totalSubmissions: [],
      totalClientSubmissions: [],
      clientSubmissions: [],
      agentSubmissions: [],
      supplierSubmissions: [],
      assignedLoader: false,
      viewGeneralSubmission: [],
      viewClientSubmissions: [],
      viewAgentSubmissions: [],
      viewSupplierSubmissions: [],
      viewLoader: true,
      submission_id: "",
      isProcessing: false,
      total_general_submissions: 0,
      total_client_submissions: 0,
      total_agent_submissions: 0,
      total_general_completed: 0,
      total_client_completed: 0,
      total_agent_completed: 0,
      //Send Email
      emailto: "",
      emailtoname: "",
      emailsubject: "",
      emailcontent: "",
      email_button: false,
      clientColumnServices: [],
      agentColumnServices: [],
      supplierColumnServices: [],
      extra_files: [],
      extra_files_clients: [],
      extra_files_agents: [],
      client_accountno: "",
      selected_client_accountno: null,
      all_active_clients: [],
      all_active_agents: [],
      selected_agent_accountno: null,
      agent_accountno: "",
      select_clients: true,
      select_agents: "general",
      selected_emails: "",
      general_submission_id: "",
      client_submission_id: "",
      client_submission_type: "",
      agent_submission_id: "",
      errorMessageResend: "",
      successMessageResend: "",
      resendLoader: false,
      //Reject General Form
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      reject_general_button: false,
      reject_general_reason: "",
      approveGeneralErrorMessage: "",
      approveGeneralSuccessMessage: "",
      approve_general_button: false,
      approvalNotes: "",
      approvalNotesError: "",
      allGeneralRejectionsListing: [],
      rejectionLoader: false,
      //CLIENTS
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
      reject_client_button: false,
      reject_client_reason: "",
      approveClientErrorMessage: "",
      approveClientSuccessMessage: "",
      approve_client_button: false,
      approvalNotes: "",
      approvalNotesError: "",
      allClientRejectionsListing: [],
      allAgentRejectionsListing: [],
      rejectionClientLoader: false,
      rejection_client_title: "",
      progressPercentage: 0,

      deleteLoader: false,
      form_submission_id: "",
      errorMessageArchiveForms: "",
      archivedForms: [],
      archived_form_title: "",

      submission_link: "",
      account_creation: 0,
      notify_client_account: false,
      create_client_account: false,

      notification_scheduler: false,
      schedule_div: false,
      repeat_count: 7,
      repeat_interval: 24,
      initial_reminder_interval: 2,
      notification_loader: false,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      user_details: "",

      listMenuGroupData: [],
      selected_group_id: "",

      copiedSub: false,
      successMessageSub: "",
      showMailForm: false,
      mailName: "",
      mailEmail: "",
      mailComment: "",
      successMessageMail: "",
      errorMessageMail: "",

      //AGENTS
      generalColumnServices: [
        {
          name: "id",
          label: "Progress",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_client_title(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "submitter_name",
          label: "Sent To",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_name_email(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "is_submitted",
          label: "Submitted",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_submitted(value)}</div>;
            },
          },
        },
        {
          name: "submitted_on",
          label: "Submitted On",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "sent_by_email",
          label: "Sent By",
          options: {
            customBodyRender: (value) => (value ? value : "---"),
          },
        },
        {
          name: "pdf_name",
          label: "Download",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{this.format_download_general(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "submission_status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{this.format_submission_status(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "id",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            style={{ cursor: "pointer" }}
                            title="Other Actions"
                            className="dropdown-toggle btn btn-icon  btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <Tooltip title="View Details" placement="top">
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.viewGeneralSubmission(value)
                                    }
                                  >
                                    <em className="icon ni ni-card-view"></em>
                                    <span>View Details</span>
                                  </a>
                                </Tooltip>
                              </li>
                              {tableMeta.rowData[2] !== 1 &&
                              (!tableMeta.rowData[8] ||
                                tableMeta.rowData[8] !== 1) ? (
                                <li>
                                  <Tooltip
                                    title="Edit Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      href={`${APP_URL}user_forms/${tableMeta.rowData[10]}`}
                                      target="_blank"
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Edit</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : null}
                              {tableMeta.rowData[2] === 0 ? (
                                <li>
                                  <Tooltip title="Resend Form" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.openResendAlert(value)
                                      }
                                    >
                                      <em className="icon ni ni-emails"></em>
                                      <span>Resend</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : null}
                              {tableMeta.rowData[2] === 1 &&
                              tableMeta.rowData[6] === 0 ? (
                                <>
                                  <li>
                                    <Tooltip
                                      title="Approve Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openApproveGeneralAlert(
                                            value,
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-done text-success"></em>
                                        <span className="text-success">
                                          Approve
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                  <li>
                                    <Tooltip
                                      title="Reject Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openRejectionAlert(
                                            value,
                                            tableMeta,
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-cross-circle text-danger"></em>
                                        <span className="text-danger">Reject</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                </>
                              ) : tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 2 ? (
                                <li>
                                  <Tooltip
                                    title="Approve Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.openApproveGeneralAlert(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-done text-success"></em>
                                      <span className="text-success">Approve</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 1 ? (
                                <li>
                                  <Tooltip
                                    title="Reject Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.openRejectionAlert(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-cross-circle text-danger"></em>
                                      <span className="text-danger">Reject</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : null}

                              <li>
                                <Tooltip
                                  title="View all rejections"
                                  placement="top"
                                >
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.modalAllRejectionsGeneral(
                                        value,
                                        tableMeta,
                                      )
                                    }
                                    className="text-danger"
                                  >
                                    <em className="icon ni ni-cross-circle"></em>
                                    <span>View Rejections</span>
                                  </a>
                                </Tooltip>
                              </li>
                              {tableMeta.rowData[8] &&
                              tableMeta.rowData[8] === 1 ? (
                                <li>
                                  <Tooltip title="Link Only" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      href={tableMeta.rowData[9]}
                                      target="_blank"
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-link-alt text-warning"></em>
                                      <span className="text-warning">
                                        Link Only
                                      </span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : null}
                              {tableMeta.rowData[8] === 0 &&
                              tableMeta.rowData[2] !== 1 ? (
                                <li>
                                  <Tooltip title="Link Only" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.get_general_submission_link(
                                          value,
                                          tableMeta,
                                          "general",
                                        )
                                      }
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-copy text-warning"></em>
                                      <span className="text-warning">
                                        Copy Link
                                      </span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : null}
                              {tableMeta.rowData[2] !== 1 ? (
                                <li>
                                  <Tooltip
                                    title="Notification Settings"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.open_notifications(
                                          value,
                                          tableMeta,
                                          "general",
                                        )
                                      }
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-bell"></em>
                                      <span>Notification Settings</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              ) : null}
                              <li>
                                <Tooltip
                                  title="Delete Submission"
                                  placement="top"
                                >
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.delete_archived_details(
                                        value,
                                        tableMeta,
                                        "general",
                                      )
                                    }
                                    className="text-danger"
                                  >
                                    <em className="icon ni ni-trash"></em>
                                    <span>Delete</span>
                                  </a>
                                </Tooltip>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
        {
          name: "link_form",
          label: "Link Only",
          options: {
            display: false,
          },
        },
        {
          name: "external_link",
          label: "Link",
          options: {
            display: false,
          },
        },
        {
          name: "form_token",
          label: "Token",
          options: {
            display: false,
          },
        },
        {
          name: "progress",
          label: "Token",
          options: {
            display: false,
          },
        },
        {
          name: "submitter_email",
          label: "Email",
          options: {
            display: false,
          },
        },
        {
          name: "account_creation",
          label: "Create Account",
          options: {
            display: false,
          },
        },
      ],
    };
  }

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  async componentDidMount() {
    let form_accountno = this.props.props.match.params.id;
    this.setState({
      errorMessage: "",
      successMessage: "",
      form_accountno: form_accountno,
    });
    const servicesResponce = await getSingleForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );
    // console.log("servicesResponce: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let form_sequence =
        servicesResponce.data.data[0]["form_sequence"] &&
        servicesResponce.data.data[0]["form_sequence"] > 0
          ? servicesResponce.data.data[0]["form_sequence"]
          : "1";
      let btn_text =
        servicesResponce.data.data[0]["btn_text"] &&
        servicesResponce.data.data[0]["btn_text"] !== ""
          ? servicesResponce.data.data[0]["btn_text"]
          : "";

      let account_creation = servicesResponce.data.data[0]["account_creation"];
      if (account_creation === 1) {
        account_creation = "Yes";
      } else {
        account_creation = "No";
      }

      this.setState({
        form_title: servicesResponce.data.data[0]["form_title"],
        form_desc: servicesResponce.data.data[0]["form_desc"],
        form_content: JSON.parse(servicesResponce.data.data[0]["form_content"]),
        showOnDashboard: servicesResponce.data.data[0]["show_on_dashboard"],
        allow_multiple: servicesResponce.data.data[0]["allow_multiple"],
        is_default: servicesResponce.data.data[0]["is_default"],
        form_status: servicesResponce.data.data[0]["status"],
        account_creation: account_creation,
        form_sequence: form_sequence,
        btn_text: btn_text,
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
    this.getAllSubmissionTotals();
    this.getTotalSubmissions();
  }

  redirectToEditResponse = (user, tableMeta) => {
    const url = `${APP_URL}forms/edit_response/${user}/${tableMeta.rowData[11]}/${tableMeta.rowData[12]}/${tableMeta.rowData[10]}`;
    window.location.href = url;
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  changeActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
      assignedLoader: true,
    });
  };

  getAllSubmissionTotals = async () => {
    const { form_accountno } = this.state;
    const servicesResponse = await getAllSubmissionTotals(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );

    // console.log("getAllSubmissionTotals: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponse.data.status === 404) {
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        total_general_submissions:
          servicesResponse.data.total_general_submissions,
        total_client_submissions:
          servicesResponse.data.total_client_submissions,
        total_agent_submissions: servicesResponse.data.total_agent_submissions,
        total_general_completed: servicesResponse.data.total_general_completed,
        total_client_completed: servicesResponse.data.total_client_completed,
        total_agent_completed: servicesResponse.data.total_agent_completed,
      });

      //window.$("#modalAssignForm").modal("show");
    } else {
    }
  };

  getTotalSubmissions = async () => {
    const { form_accountno } = this.state;
    const servicesResponse = await getTotalFormSubmissions(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );

    // console.log("getTotalSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponse.data.status === 404) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        assignedLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        errorMessageTotalsTitle: "",
        errorMessageTotals: "",
        totalSubmissions: servicesResponse.data.data,
        assignedLoader: false,
      });

      //window.$("#modalAssignForm").modal("show");
    } else {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        assignedLoader: false,
      });
    }
  };

  getClientSubmissions = async () => {
    const { form_accountno } = this.state;
    const servicesResponse = await getClientSubmissions(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );

    // console.log("getClientSubmissions: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponse.data.status === 404) {
      this.setState({
        errorMessageClientsTitle: "No Submission",
        errorMessageClients: "There are no submissions right now.",
        assignedLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        errorMessageClientsTitle: "",
        errorMessageClients: "",
        totalClientSubmissions: servicesResponse.data.data,
        clientColumnServices: [
          {
            name: "id",
            label: "Form Title",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_client_title_for_clients(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submitter_name",
            label: "Sent To",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_name_email_client(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_download(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "id",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {tableMeta.rowData[2] !== 1 &&
                                (!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] !== 1) ? (
                                  <li>
                                    <Tooltip
                                      title="View Details"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={`${AGENT_PORTAL_URL}client/client_forms/${tableMeta.rowData[10]}`}
                                        target="_blank"
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 0 ? (
                                  <>
                                    <li>
                                      <Tooltip
                                        title="Approve Submission"
                                        placement="top"
                                      >
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.openApproveClientAlert(
                                              value,
                                              "clients",
                                              tableMeta,
                                            )
                                          }
                                        >
                                          <em className="icon ni ni-done text-success"></em>
                                          <span className="text-success">
                                            Approve
                                          </span>
                                        </a>
                                      </Tooltip>
                                    </li>
                                    <li>
                                      <Tooltip
                                        title="Reject Submission"
                                        placement="top"
                                      >
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.openRejectionClientAlert(
                                              value,
                                              "clients",
                                              tableMeta,
                                            )
                                          }
                                          className="text-danger"
                                        >
                                          <em className="icon ni ni-cross-circle text-danger"></em>
                                          <span className="text-danger">
                                            Reject
                                          </span>
                                        </a>
                                      </Tooltip>
                                    </li>
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 2 ? (
                                  <li>
                                    <Tooltip
                                      title="Approve Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openApproveClientAlert(
                                            value,
                                            "clients",
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-done text-success"></em>
                                        <span className="text-success">
                                          Approve
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Reject Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openRejectionClientAlert(
                                            value,
                                            "clients",
                                            tableMeta,
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-cross-circle text-danger"></em>
                                        <span className="text-danger">Reject</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                <li>
                                  <Tooltip
                                    title="View all rejections"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.modalAllRejectionsClient(
                                          value,
                                          "clients",
                                          tableMeta,
                                        )
                                      }
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-cross-circle"></em>
                                      <span>View Rejections</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {tableMeta.rowData[8] &&
                                tableMeta.rowData[8] === 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={tableMeta.rowData[9]}
                                        target="_blank"
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-link-alt text-warning"></em>
                                        <span className="text-warning">
                                          Link Only
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[8] === 0 &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.get_general_submission_link(
                                            value,
                                            tableMeta,
                                            "clients",
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-copy text-warning"></em>
                                        <span className="text-warning">
                                          Copy Link
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Edit Response"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.redirectToEditResponse(
                                            "client",
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit Response</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] !== 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Notification settings"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.open_notifications(
                                            value,
                                            tableMeta,
                                            "clients",
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-bell"></em>
                                        <span>Notification Settings</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                <li>
                                  <Tooltip
                                    title="Delete Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta,
                                          "clients",
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "client_accountno",
            label: "Client Account #",
            options: {
              display: false,
            },
          },
          {
            name: "form_accountno",
            label: "Form Account #",
            options: {
              display: false,
            },
          },
          {
            name: "progress",
            label: "Progress",
            options: {
              display: false,
            },
          },
          {
            name: "submitter_email",
            label: "Email",
            options: {
              display: false,
            },
          },
        ],
        assignedLoader: false,
      });

      //window.$("#modalAssignForm").modal("show");
    } else {
      this.setState({
        errorMessageClientsTitle: "No Submission",
        errorMessageClients: "There are no submissions right now.",
        assignedLoader: false,
      });
    }
  };

  format_client_title = (value, tableMeta) => {
    //console.log("form general title: ", tableMeta.rowData[11]);

    let progressPercentage = 0;

    if (tableMeta.rowData[11]) {
      let progress = tableMeta.rowData[11];
      let [completed, total] = progress.split("/").map(Number);
      progressPercentage = (completed / total) * 100;
    }
    return (
      <div className="progress-list gy-3">
        <div className="progress-wrap">
          <div className="progress-text">
            <div className="progress-label text-dark fs-10">
              {this.state.form_title}
            </div>
            <div className="progress-amount text-dark">
              {progressPercentage.toFixed(2)}%
            </div>
          </div>
          <div className="progress progress-md">
            <div
              className="progress-bar bg-teal"
              data-progress={progressPercentage}
              style={{
                width: `${progressPercentage}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
    //return this.state.form_title;
  };

  format_client_title_for_clients = (value, tableMeta) => {
    //console.log("form client title: ", tableMeta.rowData[13]);

    let progressPercentage = 0;

    if (tableMeta.rowData[13]) {
      let progress = tableMeta.rowData[13];
      let [completed, total] = progress.split("/").map(Number);
      progressPercentage = (completed / total) * 100;
    }
    return (
      <div className="progress-list gy-3">
        <div className="progress-wrap">
          <div className="progress-text">
            <div className="progress-label text-dark fs-10">
              {this.state.form_title}
            </div>
            <div className="progress-amount text-dark">
              {progressPercentage.toFixed(2)}%
            </div>
          </div>
          <div className="progress progress-md">
            <div
              className="progress-bar bg-teal"
              data-progress={progressPercentage}
              style={{
                width: `${progressPercentage}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
    //return this.state.form_title;
  };

  format_approved = (value) => {
    if (value === "Yes") {
      return (
        <Tooltip title="This agreement is approved." placement="top">
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Yes
          </span>
        </Tooltip>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_submitted = (value) => {
    if (value === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_submission_status = (value, tableMeta) => {
    const is_submitted = tableMeta.rowData[2];
    if (is_submitted === 1) {
      if (value === 0) {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-done"></em> Pending Approval
          </span>
        );
      } else if (value === 1) {
        return (
          <span className="badge badge-outline-success">
            <em className="icon ni ni-caution"></em> Approved
          </span>
        );
      } else if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else if (value === 3) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-file"></em> Archived
          </span>
        );
      } else {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-caution"></em> Pending Approval
          </span>
        );
      }
    } else {
      if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else if (value === 3) {
        return (
          <span className="badge badge-outline-warning">
            <em className="icon ni ni-file"></em> Drafted
          </span>
        );
      } else {
        return "---";
      }
    }
  };

  format_download = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    let form_status = tableMeta.rowData[6];
    if (form_status !== 3) {
      if (value && value !== "") {
        return (
          <>
            <a
              onClick={() => this.downloadPdf(value, this.state.form_title)}
              title="Download PDF"
              style={{
                cursor: "pointer",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-download"></em>
              </span>
            </a>
            <a
              onClick={() =>
                this.addMenuHistory(
                  "/forms/view_client_submission/" + form_token,
                )
              }
              title="Submission View"
              style={{
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-table-view"></em>
              </span>
            </a>
          </>
        );
      } else {
        return <span className="badge badge-outline-light">---</span>;
      }
    } else {
      return (
        <a
          href={`${APP_URL}forms/view_client_submission/${form_token}`}
          title="Submission View"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
          }}
          target="_blank"
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-table-view"></em>
          </span>
        </a>
      );
    }
  };

  format_download_agent = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    let form_status = tableMeta.rowData[6];
    if (form_status !== 3) {
      if (value && value !== "") {
        return (
          <>
            <a
              onClick={() => this.downloadPdf(value, this.state.form_title)}
              title="Download PDF"
              style={{
                cursor: "pointer",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-download"></em>
              </span>
            </a>
            <a
              onClick={() =>
                this.addMenuHistory(
                  "/forms/view_agent_submission/" + form_token,
                )
              }
              title="Submission View"
              style={{
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-table-view"></em>
              </span>
            </a>
          </>
        );
      } else {
        return <span className="badge badge-outline-light">---</span>;
      }
    } else {
      return (
        <a
          href={`${APP_URL}forms/view_agent_submission/${form_token}`}
          title="Submission View"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
          }}
          target="_blank"
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-table-view"></em>
          </span>
        </a>
      );
    }
  };

  format_download_supplier = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    let form_status = tableMeta.rowData[6];
    if (form_status !== 3) {
      if (value && value !== "") {
        return (
          <>
            <a
              onClick={() => this.downloadPdf(value, this.state.form_title)}
              title="Download PDF"
              style={{
                cursor: "pointer",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-download"></em>
              </span>
            </a>
            <a
              onClick={() =>
                this.addMenuHistory(
                  "/forms/view_supplier_submission/" + form_token,
                )
              }
              title="Submission View"
              style={{
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-table-view"></em>
              </span>
            </a>
          </>
        );
      } else {
        return <span className="badge badge-outline-light">---</span>;
      }
    } else {
      return (
        <a
          href={`${APP_URL}forms/view_supplier_submission/${form_token}`}
          title="Submission View"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
          }}
          target="_blank"
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-table-view"></em>
          </span>
        </a>
      );
    }
  };

  format_download_general = (value, tableMeta) => {
    // console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    let form_status = tableMeta.rowData[6];
    if (form_status !== 3) {
      if (value && value !== "") {
        return (
          <>
            <a
              onClick={() => this.downloadPdfGeneral(value)}
              title="Download PDF"
              style={{
                cursor: "pointer",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-download"></em>
              </span>
            </a>
            <a
              onClick={() =>
                this.addMenuHistory("/forms/view_submission/" + form_token)
              }
              title="Submission View"
              style={{
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-table-view"></em>
              </span>
            </a>
          </>
        );
      } else {
        return <span className="badge badge-outline-light">---</span>;
      }
    } else {
      return (
        <a
          href={`${APP_URL}forms/view_submission/${form_token}`}
          title="Submission View"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
          }}
          target="_blank"
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-table-view"></em>
          </span>
        </a>
      );
    }
  };

  format_name_email = (value, tableMeta) => {
    //return tableMeta.rowData[1] + tableMeta.rowData[12];
    return (
      <>
        {tableMeta.rowData[1]} <br />
        {tableMeta.rowData[12]}
      </>
    );
  };
  format_name_email_client = (value, tableMeta) => {
    //return tableMeta.rowData[1] + tableMeta.rowData[12];
    return (
      <>
        {tableMeta.rowData[1]} <br />
        {tableMeta.rowData[14]}
      </>
    );
  };

  format_name_email_agents = (value, tableMeta) => {
    //return tableMeta.rowData[1] + tableMeta.rowData[12];
    return (
      <>
        {tableMeta.rowData[1]} <br />
        {tableMeta.rowData[14]}
      </>
    );
  };

  getAgentSubmissions = async () => {
    const { form_accountno } = this.state;
    const servicesResponse = await getAgentSubmissions(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );

    // console.log("getAgentSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponse.data.status === 404) {
      this.setState({
        errorMessageAgentsTitle: "No Submission",
        errorMessageAgents: "There are no submissions right now.",
        assignedLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        errorMessageAgentsTitle: "",
        errorMessageAgents: "",
        agentSubmissions: servicesResponse.data.data,
        assignedLoader: false,
        agentColumnServices: [
          {
            name: "id",
            label: "Form Title",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_client_title_for_clients(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submitter_name",
            label: "Sent To",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_name_email_agents(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_download_agent(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "id",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewAgentSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {tableMeta.rowData[2] !== 1 &&
                                (!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] !== 1) ? (
                                  <li>
                                    <Tooltip
                                      title="View Details"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={`${AGENT_PORTAL_URL}partner_forms/${tableMeta.rowData[10]}`}
                                        target="_blank"
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 0 ? (
                                  <>
                                    <li>
                                      <Tooltip
                                        title="Approve Submission"
                                        placement="top"
                                      >
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.openApproveClientAlert(
                                              value,
                                              "agents",
                                              tableMeta,
                                            )
                                          }
                                        >
                                          <em className="icon ni ni-done text-success"></em>
                                          <span className="text-success">
                                            Approve
                                          </span>
                                        </a>
                                      </Tooltip>
                                    </li>
                                    <li>
                                      <Tooltip
                                        title="Reject Submission"
                                        placement="top"
                                      >
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.openRejectionClientAlert(
                                              value,
                                              "agents",
                                              tableMeta,
                                            )
                                          }
                                          className="text-danger"
                                        >
                                          <em className="icon ni ni-cross-circle text-danger"></em>
                                          <span className="text-danger">
                                            Reject
                                          </span>
                                        </a>
                                      </Tooltip>
                                    </li>
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 2 ? (
                                  <li>
                                    <Tooltip
                                      title="Approve Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openApproveClientAlert(
                                            value,
                                            "agents",
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-done text-success"></em>
                                        <span className="text-success">
                                          Approve
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Reject Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openRejectionClientAlert(
                                            value,
                                            "agents",
                                            tableMeta,
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-cross-circle text-danger"></em>
                                        <span className="text-danger">Reject</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                <li>
                                  <Tooltip
                                    title="View all rejections"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.modalAllRejectionsClient(
                                          value,
                                          "agents",
                                          tableMeta,
                                        )
                                      }
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-cross-circle"></em>
                                      <span>View Rejections</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {tableMeta.rowData[8] &&
                                tableMeta.rowData[8] === 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={tableMeta.rowData[8]}
                                        target="_blank"
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-link-alt text-warning"></em>
                                        <span className="text-warning">
                                          Link Only
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[8] === 0 &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.get_general_submission_link(
                                            value,
                                            tableMeta,
                                            "agents",
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-copy text-warning"></em>
                                        <span className="text-warning">
                                          Copy Link
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Edit Response"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.redirectToEditResponse(
                                            "cp",
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit Submission</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] !== 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Notification settings"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.open_notifications(
                                            value,
                                            tableMeta,
                                            "agents",
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-bell"></em>
                                        <span>Notification Settings</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                <li>
                                  <Tooltip
                                    title="Delete Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta,
                                          "agents",
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },

          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "agent_accountno",
            label: `${localization.specificPortals.agentLabel} Account #`,
            options: {
              display: false,
            },
          },
          {
            name: "form_accountno",
            label: "Form Account #",
            options: {
              display: false,
            },
          },
          {
            name: "progress",
            label: "Progress",
            options: {
              display: false,
            },
          },
          {
            name: "submitter_email",
            label: "Email",
            options: {
              display: false,
            },
          },
        ],
      });

      //window.$("#modalAssignForm").modal("show");
    } else {
      this.setState({
        errorMessageAgentsTitle: "No Submission",
        errorMessageAgents: "There are no submissions right now.",
        assignedLoader: false,
      });
    }
  };

  getSupplierSubmissions = async () => {
    const { form_accountno } = this.state;
    const servicesResponse = await getSupplierSubmissions(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
    );

    // console.log("getSupplierSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponse.data.status === 404) {
      this.setState({
        errorMessageAgentsTitle: "No Submission",
        errorMessageAgents: "There are no submissions right now.",
        assignedLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        errorMessageAgentsTitle: "",
        errorMessageAgents: "",
        supplierSubmissions: servicesResponse.data.data,
        assignedLoader: false,
        supplierColumnServices: [
          {
            name: "id",
            label: "Form Title",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_client_title_for_clients(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submitter_name",
            label: "Sent To",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_name_email_agents(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_download_supplier(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "id",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewSupplierSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {tableMeta.rowData[2] !== 1 &&
                                (!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] !== 1) ? (
                                  <li>
                                    <Tooltip
                                      title="View Details"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={`${AGENT_PORTAL_URL}supplier_forms/${tableMeta.rowData[10]}`}
                                        target="_blank"
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 0 ? (
                                  <>
                                    <li>
                                      <Tooltip
                                        title="Approve Submission"
                                        placement="top"
                                      >
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.openApproveClientAlert(
                                              value,
                                              "suppliers",
                                              tableMeta,
                                            )
                                          }
                                        >
                                          <em className="icon ni ni-done text-success"></em>
                                          <span className="text-success">
                                            Approve
                                          </span>
                                        </a>
                                      </Tooltip>
                                    </li>
                                    <li>
                                      <Tooltip
                                        title="Reject Submission"
                                        placement="top"
                                      >
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.openRejectionClientAlert(
                                              value,
                                              "suppliers",
                                              tableMeta,
                                            )
                                          }
                                          className="text-danger"
                                        >
                                          <em className="icon ni ni-cross-circle text-danger"></em>
                                          <span className="text-danger">
                                            Reject
                                          </span>
                                        </a>
                                      </Tooltip>
                                    </li>
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 2 ? (
                                  <li>
                                    <Tooltip
                                      title="Approve Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openApproveClientAlert(
                                            value,
                                            "suppliers",
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-done text-success"></em>
                                        <span className="text-success">
                                          Approve
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Reject Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.openRejectionClientAlert(
                                            value,
                                            "suppliers",
                                            tableMeta,
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-cross-circle text-danger"></em>
                                        <span className="text-danger">Reject</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                <li>
                                  <Tooltip
                                    title="View all rejections"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.modalAllRejectionsClient(
                                          value,
                                          "suppliers",
                                          tableMeta,
                                        )
                                      }
                                      className="text-danger"
                                    >
                                      <em className="icon ni ni-cross-circle"></em>
                                      <span>View Rejections</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {tableMeta.rowData[8] &&
                                tableMeta.rowData[8] === 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={tableMeta.rowData[8]}
                                        target="_blank"
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-link-alt text-warning"></em>
                                        <span className="text-warning">
                                          Link Only
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[8] === 0 &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.get_general_submission_link(
                                            value,
                                            tableMeta,
                                            "suppliers",
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-copy text-warning"></em>
                                        <span className="text-warning">
                                          Copy Link
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Edit Response"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.redirectToEditResponse(
                                            "cp",
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-edit"></em>
                                        <span>Edit Submission</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {tableMeta.rowData[2] !== 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Notification settings"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.open_notifications(
                                            value,
                                            tableMeta,
                                            "suppliers",
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-bell"></em>
                                        <span>Notification Settings</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                <li>
                                  <Tooltip
                                    title="Delete Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta,
                                          "suppliers",
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },

          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "agent_accountno",
            label: `${localization.specificPortals.agentLabel} Account #`,
            options: {
              display: false,
            },
          },
          {
            name: "form_accountno",
            label: "Form Account #",
            options: {
              display: false,
            },
          },
          {
            name: "progress",
            label: "Progress",
            options: {
              display: false,
            },
          },
          {
            name: "submitter_email",
            label: "Email",
            options: {
              display: false,
            },
          },
        ],
      });

      //window.$("#modalAssignForm").modal("show");
    } else {
      this.setState({
        errorMessageAgentsTitle: "No Submission",
        errorMessageAgents: "There are no submissions right now.",
        assignedLoader: false,
      });
    }
  };

  viewGeneralSubmission = async (id) => {
    const { form_accountno } = this.state;
    this.setState({ viewLoader: true });
    const servicesResponse = await viewGeneralSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );
    window.$("#modalViewGeneralSubmission").modal("show");
    // console.log("viewGeneralSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      let progressPercentage = 0;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
        if (servicesResponse.data.data[0].progress) {
          let progress = servicesResponse.data.data[0].progress;
          let [completed, total] = progress.split("/").map(Number);
          progressPercentage = (completed / total) * 100;
        }
      }
      this.setState({
        viewGeneralSubmission: servicesResponse.data.data,
        extra_files: extra_files,
        viewLoader: false,
        progressPercentage: progressPercentage.toFixed(2),
      });

      //
    }
  };

  openResendAlert = (id, tableMeta) => {
    this.setState({
      general_submission_id: id,
      errorMessageResend: "",
      successMessageResend: "",
    });
    // console.log("resendForm: ", id);
    window.$("#modalResendAlert").modal("show");
  };

  closeResendForm = async () => {
    this.setState({
      general_submission_id: "",
    });
    window.$("#modalResendAlert").modal("hide");
  };

  resendGeneralForm = async () => {
    const { form_accountno, general_submission_id } = this.state;
    this.setState({ resendLoader: true });
    const servicesResponse = await resendGeneralForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      general_submission_id,
    );
    // console.log("resendGeneralForm: ", servicesResponse.data);
    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessageResend: "Form submission not found.",
        successMessageResend: "",
        resendLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        errorMessageResend: "",
        successMessageResend: "Form sent successfully.",
        resendLoader: false,
      });
      setTimeout(() => {
        window.$("#modalResendAlert").modal("hide");
      }, 4000);

      //
    } else {
      this.setState({
        errorMessageResend: "There is some error while resending the form.",
        successMessageResend: "",
        resendLoader: false,
      });
    }
  };

  getClientMenuGroups = async () => {
    this.setState({
      tableLoader: true,
    });
    const listClientMenuGroups = await getClientMenuActiveGroups(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("Client Menu Groups: ", listClientMenuGroups.data);
    if (
      listClientMenuGroups.data.status === 403 ||
      listClientMenuGroups.data.errors === "authentication missing" ||
      listClientMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientMenuGroups.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listClientMenuGroups.data.status === 200 &&
      listClientMenuGroups.data.message === "success"
    ) {
      this.setState({
        listMenuGroupData: listClientMenuGroups.data.data,
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  openApproveGeneralAlert = async (id, tableMeta) => {
    this.setState({
      general_submission_id: id,
      approveGeneralErrorMessage: "",
      approveGeneralSuccessMessage: "",
      approve_general_button: false,
      notify_client_account: false,
      create_client_account: false,
    });
    await this.getClientMenuGroups();
    window.$("#modalApproveGeneralAlert").modal("show");
  };

  handleApprovalNotesChange = (event) => {
    const value = event.target.value;
    this.setState({
      approvalNotes: value,
      approvalNotesError: "",
    });
  };

  approve_general_form = async () => {
    const {
      general_submission_id,
      form_accountno,
      form_title,
      account_creation,
      notify_client_account,
      create_client_account,
      selected_group_id,
      approvalNotes,
    } = this.state;
    this.setState({
      approveGeneralErrorMessage: "",
      approveGeneralSuccessMessage: "",
      approve_general_button: true,
    });
    let notifyClientAccount = notify_client_account ? "1" : "0";
    let createClientAccount = create_client_account ? "1" : "0";
    const servicesResponse = await approveGeneralSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      general_submission_id,
      form_title,
      account_creation,
      notifyClientAccount,
      createClientAccount,
      selected_group_id,
      approvalNotes,
    );

    // console.log("rejectGeneralSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 400 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There is some error while approving the submission.",
        approveGeneralSuccessMessage: "",
        approve_general_button: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let message = "Submission approved successfully.";
      if (servicesResponse.data.notes !== "") {
        if (servicesResponse.data.notes === "success") {
          message =
            "Submission approved successfully, and the client account has been created.";
        }
        if (servicesResponse.data.notes === "email_already_exists") {
          message =
            "Submission approved successfully. The client account could not be created because it already exists in our system.";
        }
        if (servicesResponse.data.notes === "registration_error") {
          message =
            "Submission approved successfully. However, the client account could not be created due to an issue. Please contact the administrator for assistance.";
        }
      }
      this.setState(
        {
          approveGeneralErrorMessage: "",
          approveGeneralSuccessMessage: message,
          reject_general_reason: "",
          approvalNotes: "",
          approvalNotesError: "",
        },
        () => {
          setTimeout(() => {
            window.$("#modalApproveGeneralAlert").modal("hide");
            this.setState({
              approveGeneralErrorMessage: "",
              approveGeneralSuccessMessage: "",
              approvalNotes: "",
              approvalNotesError: "",
            });
            //window.location.reload();
          }, 5000);
        },
      );
      this.getTotalSubmissions();
      if (servicesResponse.data.notes !== "") {
        if (servicesResponse.data.notes === "success") {
          this.changeActiveTab("client_submissions");
          this.getClientSubmissions();
        }
      }
    } else {
      this.setState({
        approve_general_button: false,
        approveGeneralErrorMessage:
          "There is some error while approving the submission.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  modalAllRejectionsGeneral = async (id, tableMeta) => {
    const { form_accountno, form_title } = this.state;
    this.setState({
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      allGeneralRejectionsListing: [],
      rejectionLoader: true,
    });
    window.$("#modalRejectionGeneral").modal("show");
    const servicesResponse = await allGeneralRejections(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );

    // console.log("allGeneralRejections: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage: "Submission not found.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "rejection_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There are no rejections against this submission.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        approveGeneralErrorMessage: "",
        approveGeneralSuccessMessage: "",

        allGeneralRejectionsListing: servicesResponse.data.data,
        rejectionLoader: false,
      });
    } else {
      this.setState({
        rejectionLoader: false,
        approveGeneralErrorMessage:
          "There is some error while getting the rejections.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  openRejectionAlert = (id, tableMeta) => {
    this.setState({
      general_submission_id: id,
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      reject_general_reason: "",
      reject_general_button: false,
    });
    // console.log("resendForm: ", id);
    window.$("#modalRejectionAlert").modal("show");
  };

  reject_general_form = async () => {
    const {
      general_submission_id,
      reject_general_reason,
      form_accountno,
      form_title,
    } = this.state;
    this.setState({
      reject_general_button: true,
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
    });
    let is_validated = true;
    if (reject_general_reason === "") {
      is_validated = false;
    }
    if (is_validated === true) {
      const servicesResponse = await rejectGeneralSubmission(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        general_submission_id,
        reject_general_reason,
        form_title,
      );

      // console.log("rejectGeneralSubmission: ", servicesResponse.data);

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 400 &&
        servicesResponse.data.message === "form_not_found"
      ) {
        this.setState({
          rejectGeneralErrorMessage:
            "There is some error while rejecting the submission.",
          rejectGeneralSuccessMessage: "",
          reject_general_button: false,
        });
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState(
          {
            rejectGeneralErrorMessage: "",
            rejectGeneralSuccessMessage: "Submission rejected successfully.",
            reject_general_button: false,
            reject_general_reason: "",
          },
          () => {
            setTimeout(() => {
              this.getTotalSubmissions();
              window.$("#modalRejectionAlert").modal("hide");
              this.setState({
                rejectGeneralErrorMessage: "",
                rejectGeneralSuccessMessage:
                  "Submission rejected successfully.",
              });
              //window.location.reload();
            }, 3000);
          },
        );
      } else {
        this.setState({
          reject_general_button: false,
          rejectGeneralErrorMessage:
            "There is some error while rejecting the submission.",
          rejectGeneralSuccessMessage: "",
        });
      }
    } else {
      this.setState({
        reject_general_button: false,
        rejectGeneralErrorMessage: "Please enter the reason.",
        rejectGeneralSuccessMessage: "",
      });
    }
  };

  /****### CLIENT/AGENT ACTIONS ###****/
  openApproveClientAlert = (id, type, tableMeta) => {
    this.setState({
      client_submission_id: id,
      client_submission_type: type,
      approveClientErrorMessage: "",
      approveClientSuccessMessage: "",
      approve_client_button: false,
    });
    window.$("#modalApproveClientAlert").modal("show");
  };

  handleApprovalNotesChange = (event) => {
    const value = event.target.value;
    this.setState({
      approvalNotes: value,
      approvalNotesError: "",
    });
  };

  approve_client_form = async () => {
    const {
      client_submission_id,
      client_submission_type,
      form_accountno,
      form_title,
      approvalNotes,
    } = this.state;
    this.setState({
      approveClientErrorMessage: "",
      approveClientSuccessMessage: "",
      approve_client_button: true,
    });

    const servicesResponse = await approveClientSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      client_submission_id,
      form_title,
      client_submission_type,
      client_submission_id,
      approvalNotes,
    );

    // console.log("approveClientSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 400 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveClientErrorMessage:
          "There is some error while approving the submission.",
        approveClientSuccessMessage: "",
        approve_client_button: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          approveClientErrorMessage: "",
          approveClientSuccessMessage: "Submission approved successfully.",
          reject_general_reason: "",
          approvalNotes: "",
          approvalNotesError: "",
        },
        () => {
          setTimeout(() => {
            if (client_submission_type === "clients") {
              this.getClientSubmissions();
            }
            if (client_submission_type === "agents") {
              this.getAgentSubmissions();
            }
            if (client_submission_type === "suppliers") {
              this.getSupplierSubmissions();
            }
            window.$("#modalApproveClientAlert").modal("hide");
            this.setState({
              approveClientErrorMessage: "",
              approveClientSuccessMessage: "",
            });
            //window.location.reload();
          }, 3000);
        },
      );
    } else {
      this.setState({
        approve_client_button: false,
        approveClientErrorMessage:
          "There is some error while approving the submission.",
        approveClientSuccessMessage: "",
      });
    }
  };

  openRejectionClientAlert = (id, type, tableMeta) => {
    let rejection_client_title = "Reject Submission";
    if (type === "clients") {
      rejection_client_title = "Reject Client Submission";
    }
    if (type === "agents") {
      rejection_client_title = `Reject ${localization.specificPortals.agentLabel} Submission`;
    }
    if (type === "suppliers") {
      rejection_client_title = `Reject ${localization.suppliersListing.text} Submission`;
    }
    this.setState({
      client_submission_id: id,
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
      reject_client_reason: "",
      reject_client_button: false,
      rejection_client_title: rejection_client_title,
      client_submission_type: type,
    });
    // console.log("resendForm: ", id);
    window.$("#modalRejectionClientAlert").modal("show");
  };

  reject_client_form = async () => {
    const {
      client_submission_id,
      reject_client_reason,
      form_accountno,
      form_title,
      client_submission_type,
    } = this.state;
    this.setState({
      reject_client_button: true,
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
    });
    let is_validated = true;
    if (reject_client_reason === "") {
      is_validated = false;
    }
    if (is_validated === true) {
      const servicesResponse = await rejectClientSubmission(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        client_submission_id,
        reject_client_reason,
        form_title,
        client_submission_type,
      );

      // console.log("reject_client_form: ", servicesResponse.data);

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 400 &&
        servicesResponse.data.message === "form_not_found"
      ) {
        this.setState({
          rejectClientErrorMessage:
            "There is some error while rejecting the submission.",
          rejectClientSuccessMessage: "",
          reject_client_button: false,
        });
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState(
          {
            rejectClientErrorMessage: "",
            rejectClientSuccessMessage: "Submission rejected successfully.",
            reject_client_button: false,
            reject_general_reason: "",
          },
          () => {
            setTimeout(() => {
              if (client_submission_type === "clients") {
                this.getClientSubmissions();
              }
              if (client_submission_type === "agents") {
                this.getAgentSubmissions();
              }
              if (client_submission_type === "suppliers") {
                this.getSupplierSubmissions();
              }
              window.$("#modalRejectionClientAlert").modal("hide");
              this.setState({
                rejectClientErrorMessage: "",
                rejectClientSuccessMessage: "Submission rejected successfully.",
              });
              //window.location.reload();
            }, 3000);
          },
        );
      } else {
        this.setState({
          reject_client_button: false,
          rejectClientErrorMessage:
            "There is some error while rejecting the submission.",
          rejectClientSuccessMessage: "",
        });
      }
    } else {
      this.setState({
        reject_client_button: false,
        rejectClientErrorMessage: "Please enter the reason.",
        rejectClientSuccessMessage: "",
      });
    }
  };

  modalAllRejectionsClient = async (id, type, tableMeta) => {
    const { form_accountno, form_title } = this.state;
    let rejection_client_title = "All Rejections";
    if (type === "clients") {
      rejection_client_title = "Client Rejections";
    }
    if (type === "agents") {
      rejection_client_title = `${localization.specificPortals.agentsLabel} Rejections`;
    }
    if (type === "suppliers") {
      rejection_client_title = `${localization.suppliersListing.text} Rejections`;
    }
    this.setState({
      client_submission_id: id,
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
      reject_client_reason: "",
      reject_client_button: false,
      rejection_client_title: rejection_client_title,
      client_submission_type: type,
    });
    this.setState({
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      allClientRejectionsListing: [],
      rejectionLoader: true,
    });
    window.$("#modalRejectionClients").modal("show");
    const servicesResponse = await allClientRejections(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
      type,
    );

    // console.log("allClientRejections: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage: "Submission not found.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "rejection_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There are no rejections against this submission.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        approveGeneralErrorMessage: "",
        approveGeneralSuccessMessage: "",
        allClientRejectionsListing: servicesResponse.data.data,
        rejectionLoader: false,
      });
    } else {
      this.setState({
        rejectionLoader: false,
        approveGeneralErrorMessage:
          "There is some error while getting the rejections.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  closeModal = (modalId) => {
    window.$("#" + modalId).modal("hide");
  };

  viewClientSubmission = async (id, tableMeta) => {
    const { form_accountno } = this.state;
    this.setState({ viewLoader: true, viewClientSubmissions: [] });
    const servicesResponse = await viewClientSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );

    window.$("#modalClientSubmission").modal("show");
    // console.log("viewClientSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      let progressPercentage = 0;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
        if (servicesResponse.data.data[0].progress) {
          let progress = servicesResponse.data.data[0].progress;
          let [completed, total] = progress.split("/").map(Number);
          progressPercentage = (completed / total) * 100;
        }
      }
      this.setState({
        viewClientSubmissions: servicesResponse.data.data,
        extra_files_clients: extra_files,
        viewLoader: false,
        progressPercentage: progressPercentage.toFixed(2),
      });

      //
    }
  };

  viewAgentSubmission = async (id, tableMeta) => {
    const { form_accountno } = this.state;
    this.setState({ viewLoader: true });
    const servicesResponse = await viewAgentSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );

    window.$("#modalAgentSubmission").modal("show");
    // console.log("viewAgentSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      let progressPercentage = 0;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
        if (servicesResponse.data.data[0].progress) {
          let progress = servicesResponse.data.data[0].progress;
          let [completed, total] = progress.split("/").map(Number);
          progressPercentage = (completed / total) * 100;
        }
      }
      this.setState({
        viewAgentSubmissions: servicesResponse.data.data,
        extra_files_agents: extra_files,
        viewLoader: false,
        progressPercentage: progressPercentage.toFixed(2),
      });

      //
    }
  };

  viewSupplierSubmission = async (id, tableMeta) => {
    const { form_accountno } = this.state;
    this.setState({ viewLoader: true });
    const servicesResponse = await viewSupplierSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );

    window.$("#modalSupplierSubmission").modal("show");
    // console.log("viewSupplierSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      let progressPercentage = 0;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
        if (servicesResponse.data.data[0].progress) {
          let progress = servicesResponse.data.data[0].progress;
          let [completed, total] = progress.split("/").map(Number);
          progressPercentage = (completed / total) * 100;
        }
      }
      this.setState({
        viewSupplierSubmissions: servicesResponse.data.data,
        extra_files_agents: extra_files,
        viewLoader: false,
        progressPercentage: progressPercentage.toFixed(2),
      });

      //
    }
  };

  deleteGeneralModal = async (id) => {
    this.setState({ submission_id: id });
    window.$("#modalDeleteGeneralAlert").modal("show");
  };

  modalHideDelGeneral = async () => {
    this.setState({ submission_id: "" });
    window.$("#modalDeleteGeneralAlert").modal("hide");
  };

  modalHideAlll = async (id) => {
    window.$("#" + id).modal("hide");
    if (id === "modalApproveClientAlert") {
      this.setState({ approvalNotes: "", approvalNotesError: "" });
    }
    if (id === "modalApproveGeneralAlert") {
      this.setState({ approvalNotes: "", approvalNotesError: "" });
    }
  };

  handleApprovalNotesChange = (event) => {
    const value = event.target.value;
    this.setState({
      approvalNotes: value,
      approvalNotesError: "",
    });
  };

  deleteGeneralSubmission = async (id) => {
    const { form_accountno, submission_id } = this.state;
    this.setState({ viewLoader: true });
    const servicesResponse = await deleteGeneralSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      submission_id,
    );

    // console.log("getTotalSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageDelete: "There are no submissions right now.",
        isProcessing: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          successMessageDelte: "Submission deleted successfully.",
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            this.getTotalSubmissions();
            window.$("#modalDeleteGeneralAlert").modal("hide");
            this.setState({ successMessage: "" });
            //window.location.reload();
          }, 3000);
        },
      );
    } else {
      this.setState({
        errorMessageDelete: "Error failed to delete submission.",
        isProcessing: false,
      });
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  fieldValidation = () => {
    let { emailtoname, emailto, emailsubject, emailcontent } = this.state;

    if (emailtoname === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Name is required.",
      });
      return false;
    } else if (emailto === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "To email address is required.",
      });
      return false;
    } else if (this.validateEmailAdd(emailto) === false) {
      this.setState({
        emailErrorMessageTitle: "Invalid Format",
        emailErrorMessage: "Invalid email address format.",
      });
      return false;
    } else if (emailsubject === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Subject is required.",
      });
      return false;
    } else if (emailcontent === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Custom content is required.",
      });
      return false;
    } else {
      this.setState({
        emailErrorMessageTitle: "",
        emailErrorMessage: "",
      });
    }
    return true;
  };

  submitFormEmail = async () => {
    const {
      form_accountno,
      emailtoname,
      emailto,
      emailsubject,
      emailcontent,
      select_agents,
      selected_emails,
    } = this.state;

    if (this.fieldValidation() === true) {
      this.setState({
        email_button: true,
        emailErrorMessage: "",
        emailErrorMessageTitle: "",
        emailSuccessMessage: "",
      });
      const servicesResponce = await sendFormEmail(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        emailtoname,
        emailto,
        emailsubject,
        emailcontent,
        select_agents,
        selected_emails,
      );
      // console.log("submitOrderEmail: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "already_sent"
      ) {
        this.setState({
          emailErrorMessageTitle: "Already Sent",
          emailErrorMessage:
            "This form has already been sent to the email and is still not submitted.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "insert_error"
      ) {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage: "This is some error while sending the form.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          emailSuccessMessage:
            "Email sent successfully. Please wait, page will refresh automatically.",
          payment_status: servicesResponce.data.data,
          emailErrorMessageTitle: "",
          emailErrorMessage: "",
          emailsubject: "",
          emailto: "",
          emailtoname: "",
          emailcontent: "",
          email_button: false,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage:
            "There is some error while processing your request.",
          email_button: false,
        });
      }
    }

    setTimeout(() => {
      this.setState({
        emailErrorMessage: "",
        emailSuccessMessage: "",
      });
    }, 4000);
  };

  downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url =
        AGENT_PORTAL_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  downloadPdfGeneral = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = APP_LIVE_URL + "files_data/form_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  downloadFormPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url =
        AGENT_PORTAL_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  listAllActiveClients = async () => {
    const servicesResponce = await listActiveClients(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("listAllActiveClients: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The question not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (
        servicesResponce.data.all_data &&
        servicesResponce.data.all_data.length > 0
      ) {
        for (let i = 0; i < servicesResponce.data.all_data.length; i++) {
          let newArr = {
            label:
              servicesResponce.data.all_data[i]["name"] +
              " (" +
              servicesResponce.data.all_data[i]["comp_name"] +
              ")",
            value:
              servicesResponce.data.all_data[i]["email"] +
              "###" +
              servicesResponce.data.all_data[i]["name"],
          };
          all_clients.push(newArr);
        }
        let newArr2 = {
          label: "Other",
          value: "other",
        };
        all_clients.push(newArr2);
      }
      this.setState({
        all_active_clients: all_clients,
      });
    } else {
      this.setState({
        errorMessage: "",
      });
    }
  };

  listActiveAgents = async () => {
    const servicesResponce = await listAgents(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("listActiveAgents: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        formLoader: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label:
              servicesResponce.data.data[i][1] +
              " (" +
              servicesResponce.data.data[i][2] +
              ")",
            value:
              servicesResponce.data.data[i][3] +
              "###" +
              servicesResponce.data.data[i][1],
          };
          all_clients.push(newArr);
        }
        let newArr2 = {
          label: "Other",
          value: "other",
        };
        all_clients.push(newArr2);
      }
      this.setState({
        all_active_agents: all_clients,
      });
    }
  };

  handleChangeSearch = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);

    if (changed_value) {
      if (changed_value.value === "other") {
        this.setState({
          selected_emails: changed_value.value,
          emailto: "",
          emailtoname: "",
        });
      } else {
        let emails = changed_value.value.split("###");
        this.setState(
          (prevState) => ({
            client_accountno: changed_value.value,
            selected_client_accountno: changed_value,
            selected_emails: "",
            emailto: emails[0],
            emailtoname: emails[1],
          }),
          () => {
            // This callback function is called right after the state is updated
            // console.log("Updated state:", this.state.client_accountno);
          },
        );
      }
    } else {
      this.setState(
        {
          client_accountno: null,
          selected_client_accountno: null,
          emailto: "",
          emailtoname: "",
          selected_emails: "",
        },
        () => {
          // console.log("Cleared selection");
        },
      );
    }
  };

  handleChangeSearchAgents = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);

    if (changed_value) {
      if (changed_value.value === "other") {
        this.setState({
          selected_emails: changed_value.value,
          emailto: "",
          emailtoname: "",
        });
      } else {
        let emails = changed_value.value.split("###");
        this.setState(
          (prevState) => ({
            agent_accountno: changed_value.value,
            selected_agent_accountno: changed_value,
            selected_emails: "",
            emailtoname: emails[1],
            emailto: emails[0],
          }),
          () => {
            // This callback function is called right after the state is updated
            // console.log("Updated state:", this.state.agent_accountno);
          },
        );
      }
    } else {
      this.setState(
        {
          agent_accountno: null,
          selected_agent_accountno: null,
          emailto: "",
          emailtoname: "",
          selected_emails: "",
        },
        () => {
          // console.log("Cleared selection");
        },
      );
    }
  };

  handleChangeSelectAgents = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      emailto: "",
    });

    //console.log("handleChangeCheckbox:", name + " " + value);
  };

  get_general_submission_link = async (value, tableMeta, type) => {
    this.setState({
      showMailForm: false,
    });
    window.$("#modalSubmissionLink").modal("show");
    const { form_accountno } = this.state;
    let id = tableMeta.rowData[0];
    let submission_type = type;
    // console.log("Sub ID: ", id);
    this.setState({
      form_submission_id: id,
      submission_type: submission_type,
      errorMessageDelete: "",
      successMessageDelte: "",
      deleteLoader: true,
      submission_link: "",
    });

    const servicesResponse = await getSubmissionLink(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
      submission_type,
    );
    // console.log("submission_link : ", servicesResponse.data);
    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessageDelete: "Form submission not found.",
        successMessageDelte: "",
        deleteLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        submission_link: servicesResponse.data.data,
        errorMessageDelete: "",
        successMessageDelte: "",
        deleteLoader: false,
      });
    } else {
      this.setState({
        errorMessageDelete:
          "There is some error while getting the submision link.",
        successMessageDelte: "",
        deleteLoader: false,
      });
    }
  };

  handleNotificationSchedule = (event) => {
    // console.log("handleNotificationSchedule: ", event.target.checked);
    let schedule = event.target.checked;
    let schedule_div = false;
    if (schedule) {
      schedule_div = true;
    }
    this.setState({
      notification_scheduler: event.target.checked,
      schedule_div: schedule_div,
    });
  };

  handleChangeInitialReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ initial_reminder_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 24) {
      this.setState({ initial_reminder_interval: numericValue });
    }
  };

  handleChangeRepeatReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 48) {
      this.setState({ repeat_interval: numericValue });
    }
  };

  handleChangeRepeatDays = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_count: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 12) {
      this.setState({ repeat_count: numericValue });
    }
  };

  open_notifications = async (value, tableMeta, type) => {
    let id = tableMeta.rowData[0];
    let submission_type = type;
    let form_accountno = this.state.form_accountno;

    let user_details = "";
    if (submission_type === "general") {
      user_details =
        tableMeta.rowData[1] + " ( " + tableMeta.rowData[12] + " )";
    } else if (submission_type === "clients") {
      user_details =
        tableMeta.rowData[1] + " ( " + tableMeta.rowData[14] + " )";
    } else if (submission_type === "agents") {
      user_details =
        tableMeta.rowData[1] + " ( " + tableMeta.rowData[14] + " )";
    } else if (submission_type === "suppliers") {
      user_details =
        tableMeta.rowData[1] + " ( " + tableMeta.rowData[14] + " )";
    }
    this.setState({
      form_submission_id: id,
      submission_type: submission_type,
      user_details: user_details,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      notification_loader: true,
    });
    // console.log("form_submission_id: ", id);
    // console.log("submission_type: ", submission_type);
    const servicesResponse = await getNotificationSettings(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
      submission_type,
    );
    // console.log("deleteSubmissionForm: ", servicesResponse.data);
    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        notificationErrorMsg: "Form submission not found.",
        notificationSuccessMsg: "",
        notification_loader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let notification_scheduler = false;
      let schedule_div = false;
      let initial_reminder_interval = 2;
      let repeat_interval = 12;
      let repeat_count = 7;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (
          servicesResponse.data.data[0]["is_active"] &&
          servicesResponse.data.data[0]["is_active"] === 1
        ) {
          notification_scheduler = true;
          schedule_div = true;
          initial_reminder_interval =
            servicesResponse.data.data[0]["initial_reminder_interval"];
          repeat_interval = servicesResponse.data.data[0]["repeat_interval"];
          repeat_count = servicesResponse.data.data[0]["repeat_count"];
        }
      }
      this.setState({
        notificationErrorMsg: "",
        notification_scheduler: notification_scheduler,
        schedule_div: schedule_div,
        repeat_count: repeat_count,
        repeat_interval: repeat_interval,
        initial_reminder_interval: initial_reminder_interval,
        notification_loader: false,
      });
    } else {
      this.setState({
        notificationErrorMsg:
          "There is some error while displaying the notification settings.",
        notificationSuccessMsg: "",
        notification_loader: false,
      });
    }
    window.$("#modalNotificationSchedule").modal("show");
  };

  submitNotifications = async () => {
    const {
      repeat_count,
      repeat_interval,
      initial_reminder_interval,
      notification_scheduler,
      form_submission_id,
      submission_type,
      form_accountno,
    } = this.state;

    this.setState({
      notification_loader: true,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
    });

    if (repeat_interval === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg: "Please enter the repeat reminder.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "" });
      }, 4000);
    } else if (repeat_count === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg:
          "Please enter the days for which this notification reminders will be sent.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "", notificationSuccessMsg: "" });
      }, 4000);
    } else {
      let notificationScheduler = notification_scheduler ? "1" : "0";
      const servicesResponse = await submitNotificationSettings(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        form_submission_id,
        submission_type,
        notificationScheduler,
        repeat_count,
        repeat_interval,
        initial_reminder_interval,
      );
      // console.log("deleteSubmissionForm: ", servicesResponse.data);
      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 404 &&
        servicesResponse.data.message === "not_found"
      ) {
        this.setState({
          notificationErrorMsg: "Form submission not found.",
          notificationSuccessMsg: "",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState({
          notificationErrorMsg: "",
          notificationSuccessMsg: "Notification settings updated successfully.",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      } else {
        this.setState({
          notificationErrorMsg:
            "There is some error while updated the notification settings.",
          notificationSuccessMsg: "",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      }
    }
  };

  delete_archived_details = (value, tableMeta, type) => {
    let id = tableMeta.rowData[0];
    let submission_type = type;
    this.setState({
      form_submission_id: id,
      submission_type: submission_type,
      errorMessageDelete: "",
      successMessageDelte: "",
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteSubmission = async (value, tableMeta, type) => {
    const { form_accountno, form_submission_id, submission_type } = this.state;
    this.setState({
      deleteLoader: true,
    });
    const servicesResponse = await deleteSubmissionForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      form_submission_id,
      submission_type,
    );
    // console.log("deleteSubmissionForm: ", servicesResponse.data);
    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessageDelete: "Form submission not found.",
        successMessageDelte: "",
        deleteLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        errorMessageDelete: "",
        successMessageDelte: "Submission delete successfully.",
        deleteLoader: false,
      });
      if (submission_type === "agents") {
        setTimeout(() => {
          this.getAgentSubmissions();
          window.$("#modalDeleteAlert").modal("hide");
        }, 3000);
      } else if (submission_type === "clients") {
        setTimeout(() => {
          this.getClientSubmissions();
          window.$("#modalDeleteAlert").modal("hide");
        }, 3000);
      } else if (submission_type === "suppliers") {
        setTimeout(() => {
          this.getSupplierSubmissions();
          window.$("#modalDeleteAlert").modal("hide");
        }, 3000);
      } else if (submission_type === "general") {
        setTimeout(() => {
          this.getTotalSubmissions();
          window.$("#modalDeleteAlert").modal("hide");
        }, 3000);
      } else {
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } else {
      this.setState({
        errorMessageDelete: "There is some error while delete the submision.",
        successMessageDelte: "",
        deleteLoader: false,
      });
    }
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  client_archived_forms = async () => {
    const kycResponce = await getClientArchivedForms(
      auth.getAccount(),
      auth.getToken(),
    );
    this.setState({ archived_form_title: "Clients Archived Submissions" });
    // console.log("client_archived_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageArchiveForms:
          "There is an error while getting the archived. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageArchiveForms: "",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedForms: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
        columnArchivedForms: [
          {
            name: "form_title",
            label: "Form Title",
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_download_form_archived(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientArchivedSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "archive_date",
            label: "Archive Date",
            options: {
              display: false,
            },
          },
          {
            name: "archive_reason",
            label: "Archive Reason",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  agent_archived_forms = async () => {
    const kycResponce = await getAgentArchivedForms(
      auth.getAccount(),
      auth.getToken(),
    );
    this.setState({
      archived_form_title: `${localization.specificPortals.agentsLabel} Archived Submissions`,
    });
    // console.log("agent_archived_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageArchiveForms:
          "There is an error while getting the archived. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageArchiveForms: "",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedForms: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
        columnArchivedForms: [
          {
            name: "form_title",
            label: "Form Title",
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_download_form_archived(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientArchivedSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "archive_date",
            label: "Archive Date",
            options: {
              display: false,
            },
          },
          {
            name: "archive_reason",
            label: "Archive Reason",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  supplier_archived_forms = async () => {
    const kycResponce = await getSuppliersArchivedForms(
      auth.getAccount(),
      auth.getToken(),
    );
    this.setState({
      archived_form_title: `${localization.suppliersListing.text} Archived Submissions`,
    });
    // console.log("agent_archived_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageArchiveForms:
          "There is an error while getting the archived. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageArchiveForms: "",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedForms: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
        columnArchivedForms: [
          {
            name: "form_title",
            label: "Form Title",
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_download_form_archived_supplier(
                      value,
                      tableMeta,
                    )}
                  </div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientArchivedSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "archive_date",
            label: "Archive Date",
            options: {
              display: false,
            },
          },
          {
            name: "archive_reason",
            label: "Archive Reason",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  general_archived_forms = async () => {
    const kycResponce = await getGeneralArchivedForms(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("general_archived_forms: ", kycResponce.data);
    this.setState({ archived_form_title: "General Archived Submission" });
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageArchiveForms:
          "There is an error while getting the archived. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageArchiveForms: "",
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedForms: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        viewLoader: false,
        columnArchivedForms: [
          {
            name: "form_title",
            label: "Form Title",
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => (value ? value : "---"),
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_download_form_archived(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientArchivedSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "archive_date",
            label: "Archive Date",
            options: {
              display: false,
            },
          },
          {
            name: "archive_reason",
            label: "Archive Reason",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  format_download_form_archived_supplier = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    if (value && value !== "") {
      return (
        <>
          <a
            onClick={() => this.downloadPdfClient(value, this.state.form_title)}
            title="Download PDF"
            style={{
              cursor: "pointer",
            }}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-download"></em>
            </span>
          </a>
          <a
            href={`${APP_URL}forms/view_supplier_archived_submission/${form_token}`}
            title="Submission View"
            style={{
              cursor: "pointer",
              marginLeft: "5px",
            }}
            target="_blank"
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-table-view"></em>
            </span>
          </a>
        </>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  format_download_form_archived = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    if (value && value !== "") {
      return (
        <>
          <a
            onClick={() => this.downloadPdfClient(value, this.state.form_title)}
            title="Download PDF"
            style={{
              cursor: "pointer",
            }}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-download"></em>
            </span>
          </a>
          <a
            href={`${APP_URL}forms/view_client_archived_submission/${form_token}`}
            title="Submission View"
            style={{
              cursor: "pointer",
              marginLeft: "5px",
            }}
            target="_blank"
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-table-view"></em>
            </span>
          </a>
        </>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  viewClientArchivedSubmission = async (value, tableMeta) => {
    const archive_date = tableMeta.rowData[11];
    const archive_reason = tableMeta.rowData[12];

    this.setState({
      form_title: tableMeta.rowData[0],
      archive_date: archive_date,
      archive_reason: archive_reason,
    });

    window.$("#modalClientArchivedSubmission").modal("show");
  };

  downloadPdfClient = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url =
        AGENT_PORTAL_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  copySubmissionLink = () => {
    navigator.clipboard.writeText(this.state.submission_link).then(() => {
      this.setState({
        successMessageSub: "Link Copied Successfully!",
        copiedSub: true,
      });
      setTimeout(
        () => this.setState({ successMessageSub: "", copiedSub: false }),
        2000,
      );
    });
  };

  sendSubmissionLinkByEmail = async () => {
    const {
      mailName,
      mailEmail,
      mailComment,
      submission_link,
      submission_type,
      form_title,
    } = this.state;

    // reset messages and disable button
    this.setState({
      successMessageMail: "",
      errorMessageMail: "",
      disabled: true,
    });

    // validations
    if (!mailName.trim()) {
      this.setState({
        errorMessageMail: "Please enter the name.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
    if (!mailEmail.trim()) {
      this.setState({
        errorMessageMail: "Please enter the email address.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
    if (ValidateEmail(mailEmail) === false) {
      this.setState({
        errorMessageMail: "Please enter a valid email address.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
    if (!mailComment.trim()) {
      this.setState({
        errorMessageMail: "Please enter the comment.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }

    try {
      let apiFunc;
      if (submission_type === "clients") {
        apiFunc = sendSubmissionLinkByEmail;
      } else if (submission_type === "agents") {
        apiFunc = sendPartnerSubmissionLinkByEmail;
      } else if (submission_type === "suppliers") {
        apiFunc = sendSupplierSubmissionLinkByEmail;
      } else {
        return this.setError("Unknown submission type.");
      }
      const response = await apiFunc(
        auth.getAccount(),
        auth.getToken(),
        mailName.trim(),
        mailEmail.trim(),
        mailComment.trim(),
        submission_link,
        auth.getUserType(),
        form_title,
      );

      const { status, message, errors } = response.data;

      if (
        status === 403 ||
        errors === "authentication missing" ||
        errors === "jwt expired"
      ) {
        return auth.logout();
      }
      if (status === 404) {
        this.setState({
          errorMessageMail:
            "There was an error while sending the submission link.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
      } else if (status === 200 && message === "success") {
        this.setState({
          successMessageMail: "Submission link successfully.",
          errorMessageMail: "",
          disabled: false,
          mailName: "",
          mailEmail: "",
          mailComment: "",
        });
        setTimeout(() => this.setState({ successMessageMail: "" }), 3000);
      } else {
        this.setState({
          errorMessageMail: "Unexpected error while sending submission link.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
      }
    } catch (error) {
      console.error("Error sending submission link:", error);
      this.setState({
        errorMessageMail: "An error occurred. Please try again later.",
        disabled: false,
      });
      setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      Forms /{" "}
                      <strong className="text-primary small">
                        {this.state.form_title}
                      </strong>
                    </h3>
                    <div className="nk-block-des text-soft">
                      <ul className="list-inline">
                        <li>
                          Form ID:{" "}
                          <span className="text-base">
                            {this.state.form_accountno}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="nk-block-head-content">
                    <a
                      onClick={() => this.addMenuHistory("/forms/")}
                      href="#"
                      className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                      <span>Back</span>
                    </a>
                    <a
                      onClick={() => this.addMenuHistory("/forms/")}
                      href="#"
                      className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                    </a>
                  </div>
                </div>
              </div>
              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-aside-wrap">
                    <div className="card-content">
                      <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "total_submissions"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("total_submissions");
                              this.getTotalSubmissions();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-file-text"></em>
                            <span>General Submissions</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "client_submissions"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("client_submissions");
                              this.getClientSubmissions();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-file-text"></em>
                            <span>Client Submissions</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "agent_submissions"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("agent_submissions");
                              this.getAgentSubmissions();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-file-text"></em>
                            <span>{`${localization.specificPortals.agentsLabel} Submissions`}</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "supplier_submissions"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("supplier_submissions");
                              this.getSupplierSubmissions();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-file-text"></em>
                            <span>{`${localization.suppliersListing.text} Submissions`}</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "email_form"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("email_form");
                              this.listAllActiveClients();
                              this.listActiveAgents();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-mail"></em>
                            <span>Email Form</span>
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div
                          className={
                            this.state.activeTab === "email_form"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="email_forms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="row g-gs">
                                <div className="col-sm-12">
                                  <h5>Send Form</h5>
                                  {this.state.emailErrorMessage !== "" ? (
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h6>
                                          {this.state.emailErrorMessageTitle}
                                        </h6>
                                        <p>{this.state.emailErrorMessage}</p>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.emailSuccessMessage !== "" ? (
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h6>Success</h6>
                                        <p>{this.state.emailSuccessMessage}</p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <ul className="nk-kycfm-control-list g-3">
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={
                                            this.state.select_agents ===
                                            "general"
                                              ? true
                                              : false
                                          }
                                          onChange={
                                            this.handleChangeSelectAgents
                                          }
                                          className="nk-kycfm-control"
                                          type="radio"
                                          name="select_agents"
                                          id="select_agents2"
                                          data-title="Select Client"
                                          value="general"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="select_agents2"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon ">
                                              <em
                                                className="icon ni ni-user-list fs-20"
                                                style={{ fontSize: "20px" }}
                                              ></em>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            General
                                          </span>
                                        </label>
                                      </li>
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={
                                            this.state.select_agents ===
                                            "clients"
                                              ? true
                                              : false
                                          }
                                          onChange={
                                            this.handleChangeSelectAgents
                                          }
                                          className="nk-kycfm-control"
                                          type="radio"
                                          name="select_agents"
                                          id="select_agents1"
                                          data-title="Select Client"
                                          value="clients"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="select_agents1"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon ">
                                              <em
                                                className="icon ni ni-user-list fs-20"
                                                style={{ fontSize: "20px" }}
                                              ></em>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            Select Client
                                          </span>
                                        </label>
                                      </li>
                                      <li className="nk-kycfm-control-item">
                                        <input
                                          checked={
                                            this.state.select_agents ===
                                            "agents"
                                              ? true
                                              : false
                                          }
                                          onChange={
                                            this.handleChangeSelectAgents
                                          }
                                          className="nk-kycfm-control"
                                          type="radio"
                                          name="select_agents"
                                          id="select_agents"
                                          data-title={`Select ${localization.specificPortals.agentsLabel}`}
                                          value="agents"
                                        autoComplete="new-password" />
                                        <label
                                          className="nk-kycfm-label"
                                          htmlFor="select_agents"
                                        >
                                          <span className="nk-kycfm-label-icon">
                                            <div className="label-icon">
                                              <em
                                                className="icon ni ni-users"
                                                style={{ fontSize: "20px" }}
                                              ></em>
                                            </div>
                                          </span>
                                          <span className="nk-kycfm-label-text">
                                            Select{" "}
                                            {
                                              localization.specificPortals
                                                .agentLabel
                                            }
                                          </span>
                                        </label>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                {this.state.select_agents === "clients" ? (
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="form-label-group">
                                        <label className="form-label">
                                          Choose Client{" "}
                                          <span className="text-danger"></span>
                                        </label>
                                      </div>
                                      <div className="form-control-group">
                                        <Select
                                          options={
                                            this.state.all_active_clients
                                          }
                                          name="selected_client_accountno"
                                          placeholder="Select a client to send the form."
                                          value={
                                            this.state.selected_client_accountno
                                          }
                                          autoComplete="off"
                                          emptyMessage="Clients not found"
                                          onChange={this.handleChangeSearch}
                                          isClearable
                                          isSearchable
                                          components={animatedComponents}
                                          styles={{
                                            control: (baseStyles, state) => ({
                                              ...baseStyles,
                                              lineHeight: "30px",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                {this.state.select_agents === "agents" ? (
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="form-label-group">
                                        <label className="form-label">
                                          Choose{" "}
                                          {
                                            localization.specificPortals
                                              .agentLabel
                                          }
                                          <span className="text-danger"></span>
                                        </label>
                                      </div>
                                      <div className="form-control-group">
                                        <Select
                                          options={this.state.all_active_agents}
                                          name="selected_agent_accountno"
                                          placeholder={`Select a ${localization.specificPortals.agentText} to send the form.`}
                                          value={
                                            this.state.selected_agent_accountno
                                          }
                                          autoComplete="off"
                                          emptyMessage={`${localization.specificPortals.agentsText} not found`}
                                          onChange={
                                            this.handleChangeSearchAgents
                                          }
                                          isClearable
                                          isSearchable
                                          components={animatedComponents}
                                          styles={{
                                            control: (baseStyles, state) => ({
                                              ...baseStyles,
                                              lineHeight: "30px",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="row col-md-12">
                                  <div className="col-sm-6">
                                    <div className="form-group mt-2">
                                      <label className="form-label" for="emailto">
                                        To Name <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailtoname"
                                          name="emailtoname"
                                          value={this.state.emailtoname}
                                          onChange={this.handleChange}
                                          placeholder="Enter the full name"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group mt-2">
                                      <label className="form-label" for="emailto">
                                        To <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailto"
                                          name="emailto"
                                          value={this.state.emailto}
                                          onChange={this.handleChange}
                                          placeholder="Enter email address"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="emailsubject"
                                      >
                                        Subject <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailsubject"
                                          name="emailsubject"
                                          value={this.state.emailsubject}
                                          onChange={this.handleChange}
                                          placeholder="Email Subject"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="emailcontent"
                                      >
                                        Custom Message <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <textarea
                                          className="form-control"
                                          id="emailcontent"
                                          name="emailcontent"
                                          value={this.state.emailcontent}
                                          onChange={this.handleChange}
                                        ></textarea>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12 mt-2 d-flex justify-content-end">
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools gx-3">
                                      {this.state.email_button === true ? (
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          disabled
                                        >
                                          <span
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          <span> Processing... </span>
                                        </button>
                                      ) : (
                                        <li>
                                          <a
                                            onClick={() =>
                                              this.submitFormEmail()
                                            }
                                            style={{
                                              cursor: "pointer",
                                              color: "#fff",
                                            }}
                                            className="btn btn-primary"
                                          >
                                            <em className="icon ni ni-check-round-cut"></em>{" "}
                                            <span>Send Email</span>{" "}
                                          </a>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* EMAIL FORM */}
                        <div
                          className={
                            this.state.activeTab === "total_submissions"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between-md g-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title">
                                      General Submissions
                                    </h5>
                                  </div>
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools g-4 flex-wrap">
                                      <li className="order-md-last">
                                        <a
                                          onClick={(e) => {
                                            this.changeActiveTab(
                                              "archived_forms",
                                            );
                                            this.general_archived_forms();
                                          }}
                                          href="#"
                                          className="btn btn-white btn-dim btn-outline-primary"
                                        >
                                          <em className="icon ni ni-archived"></em>
                                          <span>Archived Submissions</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div className="caption-text">
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={
                                            this.state.generalColumnServices
                                          }
                                          tableData={
                                            this.state.totalSubmissions
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* EMAIL FORM */}
                        {/* CLIENT SUBMISSIONS */}
                        <div
                          className={
                            this.state.activeTab === "client_submissions"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements2"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between-md g-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title">
                                      Client Submissions
                                    </h5>
                                  </div>
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools g-4 flex-wrap">
                                      <li className="order-md-last">
                                        <a
                                          onClick={(e) => {
                                            this.changeActiveTab(
                                              "archived_forms",
                                            );
                                            this.client_archived_forms();
                                          }}
                                          href="#"
                                          className="btn btn-white btn-dim btn-outline-primary"
                                        >
                                          <em className="icon ni ni-archived"></em>
                                          <span>Archived Submissions</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div className="caption-text">
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={
                                            this.state.clientColumnServices
                                          }
                                          tableData={
                                            this.state.totalClientSubmissions
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* CLIENT SUBMISSIONS */}
                        {/* AGENT SUBMISSIONS */}
                        <div
                          className={
                            this.state.activeTab === "agent_submissions"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements3"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between-md g-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title">
                                      {`${localization.specificPortals.agentsLabel} Submissions`}
                                    </h5>
                                  </div>
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools g-4 flex-wrap">
                                      <li className="order-md-last">
                                        <a
                                          onClick={(e) => {
                                            this.changeActiveTab(
                                              "archived_forms",
                                            );
                                            this.agent_archived_forms();
                                          }}
                                          href="#"
                                          className="btn btn-white btn-dim btn-outline-primary"
                                        >
                                          <em className="icon ni ni-archived"></em>
                                          <span>Archived Submissions</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div className="caption-text">
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={
                                            this.state.agentColumnServices
                                          }
                                          tableData={
                                            this.state.agentSubmissions
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* AGENT SUBMISSIONS */}
                        {/* Supplier SUBMISSIONS */}
                        <div
                          className={
                            this.state.activeTab === "supplier_submissions"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements4"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between-md g-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title">
                                      {`${localization.suppliersListing.text} Submissions`}
                                    </h5>
                                  </div>
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools g-4 flex-wrap">
                                      <li className="order-md-last">
                                        <a
                                          onClick={(e) => {
                                            this.changeActiveTab(
                                              "archived_forms",
                                            );
                                            this.supplier_archived_forms();
                                          }}
                                          href="#"
                                          className="btn btn-white btn-dim btn-outline-primary"
                                        >
                                          <em className="icon ni ni-archived"></em>
                                          <span>Archived Submissions</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div className="caption-text">
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={
                                            this.state.supplierColumnServices
                                          }
                                          tableData={
                                            this.state.supplierSubmissions
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* Supplier SUBMISSIONS */}
                        {/***** Archived Forms *****/}
                        <div
                          className={
                            this.state.activeTab === "archived_forms"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemArchivedForms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="modal-title mb-4" style={{}}>
                                  <h5>
                                    <em className="icon ni ni-card-view"></em>{" "}
                                    {this.state.archived_form_title}
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        {this.state.errorMessageArchiveForms !==
                                        "" ? (
                                          <div className="example-alert example-alert-revoke">
                                            <div className="alert alert-pro alert-danger">
                                              <div className="alert-text">
                                                <h4>Error</h4>
                                                <p>
                                                  {
                                                    this.state
                                                      .errorMessageArchiveForms
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        <div className="card card-bordered card-preview">
                                          <DataTableExtended
                                            columns={
                                              this.state.columnArchivedForms
                                            }
                                            tableData={this.state.archivedForms}
                                            title=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Archived Forms *****/}
                        <div className="nk-divider divider md"></div>
                      </div>
                    </div>
                    <div
                      className="card-aside card-aside-right user-aside d-none"
                      data-content="userAside"
                      data-toggle-screen="xxl"
                      data-toggle-overlay="true"
                      data-toggle-body="true"
                    >
                      <div className="card-inner-group" data-simplebar>
                        <div className="card-inner">
                          <div className="user-card user-card-s2">
                            <div className="user-info">
                              {this.state.form_status &&
                              this.state.form_status === 1 ? (
                                <div className="badge badge-outline-success badge-pill ucap">
                                  Active
                                </div>
                              ) : (
                                <div className="badge badge-outline-light badge-pill ucap">
                                  Inactive
                                </div>
                              )}

                              <h5>{this.state.form_title}</h5>
                              <span className="sub-text"></span>
                            </div>
                          </div>
                        </div>

                        <div className="card-inner">
                          <h6 className="overline-title-alt mb-2">
                            Completed / Pending
                          </h6>
                          <div className="row text-center">
                            <div className="col-4">
                              <div className="profile-stats">
                                <span className="amount">
                                  {this.state.total_general_completed} /{" "}
                                  {this.state.total_general_submissions}
                                </span>
                                <span className="sub-text">General</span>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="profile-stats">
                                <span className="amount">
                                  {this.state.total_client_completed} /{" "}
                                  {this.state.total_client_submissions}
                                </span>
                                <span className="sub-text">Client</span>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="profile-stats">
                                <span className="amount">
                                  {this.state.total_agent_completed} /{" "}
                                  {this.state.total_agent_submissions}
                                </span>
                                <span className="sub-text">CP</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*<div className="card-inner">
                          <h6 className="overline-title-alt mb-2">Additional</h6>
                          <div className="row g-3">
                            <div className="col-6">
                              <span className="sub-text">User ID:</span>
                              <span>UD003054</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Last Login:</span>
                              <span>15 Feb, 2019 01:02 PM</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">KYC Status:</span>
                              <span className="lead-text text-success">
                                Approved
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Register At:</span>
                              <span>Nov 24, 2019</span>
                            </div>
                          </div>
                        </div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* View General Submissions */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalViewGeneralSubmission"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> Submission
                          Details{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.viewLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                {this.state.viewGeneralSubmission &&
                                this.state.viewGeneralSubmission.length > 0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        Form Submission Details
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <table className="table table-bordered table-striped">
                                        {this.state.viewGeneralSubmission.map(
                                          (general, index) => (
                                            <tbody
                                              key={index}
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>Progress</td>
                                                <td>
                                                  <div className="card card-bordered card-preview">
                                                    <div className="card-inner viewClient_card-inner_customStyle">
                                                      <div className="progress progress-lg">
                                                        <div
                                                          className="progress-bar"
                                                          data-progress={
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          style={{
                                                            width: `${this.state.progressPercentage}%`,
                                                          }}
                                                        >
                                                          {
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          %
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Name</td>
                                                <td>
                                                  {general.submitter_name}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Email</td>
                                                <td>
                                                  {general.submitter_email}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent By</td>
                                                <td>{general.sent_by_email}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Date</td>
                                                <td>
                                                  {this.format_date(
                                                    general.sent_on,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submitted</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <span className="badge badge-dot badge-success">
                                                      Yes
                                                    </span>
                                                  ) : (
                                                    <span className="badge badge-dot badge-danger">
                                                      No
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submission Date</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1
                                                    ? this.format_date(
                                                        general.submitted_on,
                                                      )
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>View PDF</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadPdfGeneral(
                                                          general.pdf_name,
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-outline-dark">
                                                        View
                                                      </span>
                                                    </a>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Extra Files</td>
                                                <td>
                                                  {this.state.extra_files &&
                                                  this.state.extra_files !==
                                                    "" ? (
                                                    <>
                                                      {this.state.extra_files.map(
                                                        (file, index) => (
                                                          <>
                                                            {file.file_name &&
                                                            file.file_name !==
                                                              "" ? (
                                                              <div
                                                                key={index}
                                                                className="col-md-12"
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              >
                                                                {file.field_name.trim()}{" "}
                                                                <span
                                                                  onClick={() =>
                                                                    this.downloadPdfGeneral(
                                                                      file.trim(),
                                                                    )
                                                                  }
                                                                  className="badge badge-outline-primary"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  title="Download / View"
                                                                >
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  {file.file_name.trim()}
                                                                </span>
                                                              </div>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Subject</td>
                                                <td>{general.email_subject}</td>
                                              </tr>

                                              <tr>
                                                <td>Sent Form Message</td>
                                                <td>{general.email_content}</td>
                                              </tr>
                                            </tbody>
                                          ),
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View General Submissions */}

              {/* View Client Submissions */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalClientSubmission"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> Submission
                          Details{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.viewLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                {this.state.viewClientSubmissions &&
                                this.state.viewClientSubmissions.length > 0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        Form Submission Details
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <table className="table table-bordered table-striped">
                                        {this.state.viewClientSubmissions.map(
                                          (general, index) => (
                                            <tbody
                                              key={index}
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>Progress</td>
                                                <td>
                                                  <div className="card card-bordered card-preview">
                                                    <div className="card-inner viewClient_card-inner_customStyle">
                                                      <div className="progress progress-lg">
                                                        <div
                                                          className="progress-bar"
                                                          data-progress={
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          style={{
                                                            width: `${this.state.progressPercentage}%`,
                                                          }}
                                                        >
                                                          {
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          %
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Name</td>
                                                <td>
                                                  {general.submitter_name}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Email</td>
                                                <td>
                                                  {general.submitter_email}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent By</td>
                                                <td>{general.sent_by_email}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Date</td>
                                                <td>
                                                  {this.format_date(
                                                    general.sent_on,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submitted</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <span className="badge badge-dot badge-success">
                                                      Yes
                                                    </span>
                                                  ) : (
                                                    <span className="badge badge-dot badge-danger">
                                                      No
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submission Date</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1
                                                    ? this.format_date(
                                                        general.submitted_on,
                                                      )
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>View PDF</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadFormPdf(
                                                          general.pdf_name,
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-outline-dark">
                                                        View
                                                      </span>
                                                    </a>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Extra Files</td>
                                                <td>
                                                  {this.state
                                                    .extra_files_clients &&
                                                  this.state
                                                    .extra_files_clients !==
                                                    "" ? (
                                                    <>
                                                      {this.state.extra_files_clients.map(
                                                        (file, index) => (
                                                          <>
                                                            {file.file_name &&
                                                            file.file_name !==
                                                              "" ? (
                                                              <div
                                                                key={index}
                                                                className="col-md-12"
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              >
                                                                {file.field_name.trim()}{" "}
                                                                <span
                                                                  onClick={() =>
                                                                    this.downloadFormPdf(
                                                                      file.file_name.trim(),
                                                                    )
                                                                  }
                                                                  className="badge badge-outline-primary"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  title="Download / View"
                                                                >
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  {file.file_name.trim()}
                                                                </span>
                                                              </div>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Subject</td>
                                                <td>{general.email_subject}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Message</td>
                                                <td>{general.email_content}</td>
                                              </tr>
                                            </tbody>
                                          ),
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View Client Submissions */}

              {/* View Client Submissions */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalAgentSubmission"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em>{" "}
                          {`${localization.specificPortals.agentLabel} Submission Details`}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.viewLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                {this.state.viewAgentSubmissions &&
                                this.state.viewAgentSubmissions.length > 0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        Form Submission Details
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <table className="table table-bordered table-striped">
                                        {this.state.viewAgentSubmissions.map(
                                          (general, index) => (
                                            <tbody
                                              key={index}
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>Progress</td>
                                                <td>
                                                  <div className="card card-bordered card-preview">
                                                    <div className="card-inner viewClient_card-inner_customStyle">
                                                      <div className="progress progress-lg">
                                                        <div
                                                          className="progress-bar"
                                                          data-progress={
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          style={{
                                                            width: `${this.state.progressPercentage}%`,
                                                          }}
                                                        >
                                                          {
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          %
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Name</td>
                                                <td>
                                                  {general.submitter_name}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Email</td>
                                                <td>
                                                  {general.submitter_email}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent By</td>
                                                <td>{general.sent_by_email}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Date</td>
                                                <td>
                                                  {this.format_date(
                                                    general.sent_on,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submitted</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <span className="badge badge-dot badge-success">
                                                      Yes
                                                    </span>
                                                  ) : (
                                                    <span className="badge badge-dot badge-danger">
                                                      No
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submission Date</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1
                                                    ? this.format_date(
                                                        general.submitted_on,
                                                      )
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>View PDF</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadFormPdf(
                                                          general.pdf_name,
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-outline-dark">
                                                        View
                                                      </span>
                                                    </a>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Extra Files</td>
                                                <td>
                                                  {this.state
                                                    .extra_files_agents &&
                                                  this.state
                                                    .extra_files_agents !==
                                                    "" ? (
                                                    <>
                                                      {this.state.extra_files_agents.map(
                                                        (file, index) => (
                                                          <>
                                                            {file.file_name &&
                                                            file.file_name !==
                                                              "" ? (
                                                              <div
                                                                key={index}
                                                                className="col-md-12"
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              >
                                                                {file.field_name.trim()}{" "}
                                                                <span
                                                                  onClick={() =>
                                                                    this.downloadFormPdf(
                                                                      file.file_name.trim(),
                                                                    )
                                                                  }
                                                                  className="badge badge-outline-primary"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  title="Download / View"
                                                                >
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  {file.file_name.trim()}
                                                                </span>
                                                              </div>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Subject</td>
                                                <td>{general.email_subject}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Message</td>
                                                <td>{general.email_content}</td>
                                              </tr>
                                            </tbody>
                                          ),
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View Agent Submissions */}
              {/* View Supplier Submissions */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalSupplierSubmission"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em>{" "}
                          {`${localization.suppliersListing.text} Submission Details`}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.viewLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                {this.state.viewSupplierSubmissions &&
                                this.state.viewSupplierSubmissions.length >
                                  0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        Form Submission Details
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <table className="table table-bordered table-striped">
                                        {this.state.viewSupplierSubmissions.map(
                                          (general, index) => (
                                            <tbody
                                              key={index}
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>Progress</td>
                                                <td>
                                                  <div className="card card-bordered card-preview">
                                                    <div className="card-inner viewClient_card-inner_customStyle">
                                                      <div className="progress progress-lg">
                                                        <div
                                                          className="progress-bar"
                                                          data-progress={
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          style={{
                                                            width: `${this.state.progressPercentage}%`,
                                                          }}
                                                        >
                                                          {
                                                            this.state
                                                              .progressPercentage
                                                          }
                                                          %
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Name</td>
                                                <td>
                                                  {general.submitter_name}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Email</td>
                                                <td>
                                                  {general.submitter_email}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent By</td>
                                                <td>{general.sent_by_email}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Date</td>
                                                <td>
                                                  {this.format_date(
                                                    general.sent_on,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submitted</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <span className="badge badge-dot badge-success">
                                                      Yes
                                                    </span>
                                                  ) : (
                                                    <span className="badge badge-dot badge-danger">
                                                      No
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submission Date</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1
                                                    ? this.format_date(
                                                        general.submitted_on,
                                                      )
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>View PDF</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadFormPdf(
                                                          general.pdf_name,
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-outline-dark">
                                                        View
                                                      </span>
                                                    </a>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Extra Files</td>
                                                <td>
                                                  {this.state
                                                    .extra_files_agents &&
                                                  this.state
                                                    .extra_files_agents !==
                                                    "" ? (
                                                    <>
                                                      {this.state.extra_files_agents.map(
                                                        (file, index) => (
                                                          <>
                                                            {file.file_name &&
                                                            file.file_name !==
                                                              "" ? (
                                                              <div
                                                                key={index}
                                                                className="col-md-12"
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              >
                                                                {file.field_name.trim()}{" "}
                                                                <span
                                                                  onClick={() =>
                                                                    this.downloadFormPdf(
                                                                      file.file_name.trim(),
                                                                    )
                                                                  }
                                                                  className="badge badge-outline-primary"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  title="Download / View"
                                                                >
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  {file.file_name.trim()}
                                                                </span>
                                                              </div>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Subject</td>
                                                <td>{general.email_subject}</td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Message</td>
                                                <td>{general.email_content}</td>
                                              </tr>
                                            </tbody>
                                          ),
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View Supplier Submissions */}
              {/* START REJECTION MODAL */}
              <div className="modal fade" tabindex="-1" id="modalRejectionAlert">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        Reject Submission{" "}
                        <sup className="text-primary">
                          {this.state.form_title}
                        </sup>
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.rejectGeneralErrorMessage !== "" ? (
                        <div className="alert alert-pro alert-danger mb-2">
                          <div className="alert-text">
                            <h6>Error</h6>
                            <p>{this.state.rejectGeneralErrorMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      {this.state.rejectGeneralSuccessMessage !== "" ? (
                        <div className="alert alert-pro alert-success mb-2">
                          <div className="alert-text">
                            <h6>Success</h6>
                            <p>{this.state.rejectGeneralSuccessMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      <div id="revokeReasonItems">
                        <div className="tb-odr-id">Reason to reject</div>
                        <div className="card card-bordered card-preview mt-1">
                          <TextareaAutosize
                            maxrows={4}
                            name="reject_general_reason"
                            id="reject_general_reason"
                            aria-label=""
                            placeholder=""
                            value={this.state.reject_general_reason}
                            helperText="Reason to reject this submission"
                            onChange={this.handleChange}
                            style={{
                              width: "100%",
                              height: "100px",
                              borderColor: "rgba(0, 0, 0, 0.125)",
                              borderRadius: "4px",
                            }}
                            variant="outlined"
                          />
                        </div>
                        <div className="form-group text-right mt-2 mb-2">
                          {this.state.reject_general_button === true ? (
                            <button
                              className="btn btn-primary"
                              type="button"
                              disabled
                            >
                              <span
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span> Loading... </span>
                            </button>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="btn btn-light"
                                onClick={() => {
                                  this.closeModal("modalRejectionAlert");
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <em className="icon ni ni-cross-round"></em>{" "}
                                <span>Cancel</span>
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                  this.reject_general_form();
                                }}
                                disabled={this.state.disabled}
                              >
                                <em className="icon ni ni-cross-circle"></em>{" "}
                                <span>Reject</span>
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END REJECTION MODAL */}
              {/* START APPROVE MODAL  */}
              <div
                className="modal fade"
                tabindex="-1"
                id="modalApproveGeneralAlert"
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-done"></em> Approve Submission?
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.approveGeneralErrorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.approveGeneralErrorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.approveGeneralSuccessMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.approveGeneralSuccessMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="card card-bordered">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div className="between-center flex-wrap flex-md-nowrap g-3">
                              <div className="nk-block-text">
                                <h6>
                                  Are you sure you want to approve this
                                  submission?
                                </h6>
                                {this.state.account_creation === "Yes" ? (
                                  <p className="text-soft">
                                    This form includes an account creation
                                    option. For example, if you approve the form
                                    by selecting "Create New Client" below, a
                                    new client will be created using the mapped
                                    email and other provided details.
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          {this.state.account_creation === "Yes" ? (
                            <>
                              <div className="card-inner">
                                <div className="between-center flex-wrap flex-md-nowrap g-3">
                                  <div
                                    className="custom-control custom-control-lg custom-checkbox col-lg-12"
                                    style={{ padding: 0, marginLeft: "3rem" }}
                                  >
                                    <div className="form-group">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck3"
                                        onChange={() => {
                                          const isChecked =
                                            !this.state.create_client_account;
                                          this.setState({
                                            create_client_account: isChecked,
                                          });
                                          // console.log(
                                          //   "create_client_account Checkbox Checked:",
                                          //   isChecked
                                          // );
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        for="customCheck3"
                                      >
                                        Create New Client
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                {this.state.listMenuGroupData &&
                                  this.state.listMenuGroupData.length > 0 && (
                                    <div className="form-group mt-4">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="selected_group_id"
                                          name="selected_group_id"
                                          select
                                          label="Select Client Type"
                                          value={this.state.selected_group_id}
                                          onChange={this.handleChange}
                                          SelectProps={{
                                            native: true, // Renders as basic <select>
                                          }}
                                          helperText="Choose client type"
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        >
                                          <option
                                            key="group_default"
                                            value=""
                                          ></option>
                                          {this.state.listMenuGroupData &&
                                            this.state.listMenuGroupData
                                              .length > 0 &&
                                            this.state.listMenuGroupData.map(
                                              (group, index) => (
                                                <option
                                                  key={`group_${index}`}
                                                  value={group[4]}
                                                >
                                                  {group[1]}{" "}
                                                </option>
                                              ),
                                            )}
                                        </MutextField>
                                      </div>
                                    </div>
                                  )}
                                <p className="text-soft mt-4">
                                  If a new client is created successfully, the
                                  current general form submission will be copied
                                  to that client along with all submitted data.
                                  The original general submission will then be
                                  removed.
                                </p>
                              </div>
                              <div className="card-inner">
                                <div className="between-center flex-wrap flex-md-nowrap g-3">
                                  <div
                                    className="custom-control custom-control-lg custom-checkbox col-lg-12"
                                    style={{ padding: 0, marginLeft: "3rem" }}
                                  >
                                    <div className="form-group">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck2"
                                        onChange={() => {
                                          const isChecked =
                                            !this.state.notify_client_account;
                                          this.setState({
                                            notify_client_account: isChecked,
                                          });
                                          // console.log(
                                          //   "Notify Checkbox Checked:",
                                          //   isChecked
                                          // );
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        for="customCheck2"
                                      >
                                        Notify Client
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                          <div className="card-inner" style={{ marginTop: "20px" }}>
                            <div className="form-group">
                              <label style={{ fontWeight: "600", marginBottom: "10px", display: "block", fontSize: "14px", color: "#333" }}>
                                Approval Notes (Optional)
                              </label>
                              <TextareaAutosize
                                rowsMin={3}
                                placeholder="Enter approval notes..."
                                value={this.state.approvalNotes}
                                onChange={this.handleApprovalNotesChange}
                                style={{
                                  width: "100%",
                                  padding: "12px",
                                  borderRadius: "4px",
                                  border: this.state.approvalNotesError ? "1px solid #dc3545" : "1px solid #e0e0e0",
                                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                  fontSize: "13px",
                                  lineHeight: "1.5",
                                  boxSizing: "border-box",
                                  resize: "vertical",
                                  backgroundColor: "#fff",
                                  color: "#333",
                                  transition: "border-color 0.2s"
                                }}
                              />
                              {this.state.approvalNotesError && (
                                <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "6px" }}>
                                  {this.state.approvalNotesError}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end bg-light p-4">
                      {this.state.approve_general_button ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Processing... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer", marginRight: "5px" }}
                            className="btn btn-lg btn-dim btn-outline-light"
                            onClick={() => {
                              this.modalHideAlll("modalApproveGeneralAlert");
                            }}
                          >
                            <em className="icon ni ni-cross-round"></em>{" "}
                            <span>Cancel</span>
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.approve_general_form();
                            }}
                            disabled={
                              this.state.disabled || this.state.isProcessing
                            } // disable button when processing
                          >
                            <em className="icon ni ni-done"></em>{" "}
                            <span>Approve</span>
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                tabIndex="-1"
                id="modalApproveGeneralAlertOld"
              >
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideAlll("modalApproveGeneralAlert");
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-xl">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-done bg-success"></em>

                        <h4 className="nk-modal-title">Approve Submission?</h4>

                        <div className="nk-modal-text">
                          {this.state.approveGeneralErrorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.approveGeneralErrorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.approveGeneralSuccessMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>
                                    {this.state.approveGeneralSuccessMessage}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="caption-text">
                            Are you sure you want to approve this submission?{" "}
                            {this.state.account_creation}
                          </div>
                          {this.state.account_creation === "Yes" ? (
                            <>
                              <div className="caption-text">
                                This form includes an account creation option.
                                For example, if you approve the form by
                                selecting "Create Account" below, a new client
                                will be created using the mapped email and other
                                provided details.
                              </div>
                              <div
                                className="custom-control custom-control-lg custom-checkbox col-lg-12"
                                style={{ padding: 0, marginLeft: "3rem" }}
                              >
                                <div className="form-group">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="customCheck2"
                                    onChange={() => {
                                      const isChecked =
                                        !this.state.notify_client_account;
                                      this.setState({
                                        notify_client_account: isChecked,
                                      });
                                      // console.log(
                                      //   "Notify Checkbox Checked:",
                                      //   isChecked
                                      // );
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="customCheck2"
                                  >
                                    Notify Client
                                  </label>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                        <div className="nk-modal-action">
                          {this.state.approve_general_button ? (
                            <button
                              className="btn btn-lg btn-primary"
                              type="button"
                              disabled
                            >
                              <span
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span> Processing... </span>
                            </button>
                          ) : (
                            <>
                              <a
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-dim btn-outline-light"
                                onClick={() => {
                                  this.modalHideAlll(
                                    "modalApproveGeneralAlert",
                                  );
                                }}
                              >
                                <em className="icon ni ni-cross-round"></em>{" "}
                                <span>Cancel</span>
                              </a>
                              {"  "}
                              <a
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-mw btn-primary"
                                onClick={() => {
                                  this.approve_general_form();
                                }}
                                disabled={
                                  this.state.disabled || this.state.isProcessing
                                } // disable button when processing
                              >
                                <em className="icon ni ni-done"></em>{" "}
                                <span>Approve</span>
                              </a>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END APPROVE MODAL  */}
              {/* START REJECTIONS MODAL */}
              <div className="modal fade" tabindex="-1" id="modalRejectionGeneral">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {this.state.rejection_client_title}{" "}
                        <sup className="text-primary">
                          {this.state.form_title}
                        </sup>
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.rejectGeneralErrorMessage !== "" ? (
                        <div className="alert alert-pro alert-danger mb-2">
                          <div className="alert-text">
                            <h6>Error</h6>
                            <p>{this.state.rejectGeneralErrorMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      {this.state.rejectGeneralSuccessMessage !== "" ? (
                        <div className="alert alert-pro alert-success mb-2">
                          <div className="alert-text">
                            <h6>Success</h6>
                            <p>{this.state.rejectGeneralSuccessMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      <div id="revokeReasonItems">
                        {this.state.rejectionLoader === true ? (
                          FormLoader()
                        ) : (
                          <>
                            <div>
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  {this.state.allGeneralRejectionsListing &&
                                  this.state.allGeneralRejectionsListing
                                    .length > 0 ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          All Rejections
                                        </h6>
                                      </div>
                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <table className="table table-bordered table-striped">
                                          <thead>
                                            <th>Form Title</th>
                                            <th>Rejection date</th>
                                            <th>Reason</th>
                                            <th>Submitted PDF</th>
                                          </thead>
                                          {this.state.allGeneralRejectionsListing.map(
                                            (general, index) => (
                                              <tbody
                                                key={`ind${index}`}
                                                className="text-dark"
                                              >
                                                <tr>
                                                  <td>
                                                    {this.state.form_title}
                                                  </td>
                                                  <td>
                                                    {this.format_date(
                                                      general.rejection_date,
                                                    )}
                                                  </td>
                                                  <td>
                                                    {general.rejection_reason}
                                                  </td>
                                                  <td>
                                                    {general.is_submitted &&
                                                    general.is_submitted ===
                                                      1 ? (
                                                      <a
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          this.downloadPdfGeneral(
                                                            general.pdf_name,
                                                          )
                                                        }
                                                      >
                                                        <span className="badge badge-outline-dark">
                                                          View
                                                        </span>
                                                      </a>
                                                    ) : (
                                                      "---"
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            ),
                                          )}
                                        </table>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>No Rejection</h6>
                                        <p>
                                          Rejections are not available against
                                          this submission.
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END REJECTIONS MODAL */}
              {/* START APPROVE Client MODAL  */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalApproveClientAlert"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideAlll("modalApproveClientAlert");
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-done bg-success"></em>

                        <h4 className="nk-modal-title">Approve Submission?</h4>

                        <div className="nk-modal-text">
                          {this.state.approveClientErrorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.approveClientErrorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.approveClientSuccessMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>
                                    {this.state.approveClientSuccessMessage}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="caption-text">
                            Are you sure you want to approve this submission
                          </div>

                          <div style={{ marginTop: "20px", textAlign: "left", marginBottom: "20px" }}>
                            <label style={{ fontWeight: "600", marginBottom: "10px", display: "block", fontSize: "14px", color: "#333" }}>
                              Approval Notes (Optional)
                            </label>
                            <TextareaAutosize
                              rowsMin={3}
                              placeholder="Enter approval notes..."
                              value={this.state.approvalNotes}
                              onChange={this.handleApprovalNotesChange}
                              style={{
                                width: "100%",
                                padding: "12px",
                                borderRadius: "4px",
                                border: this.state.approvalNotesError ? "1px solid #dc3545" : "1px solid #e0e0e0",
                                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                fontSize: "13px",
                                lineHeight: "1.5",
                                boxSizing: "border-box",
                                resize: "vertical",
                                backgroundColor: "#fff",
                                color: "#333",
                                height: "100px",
                                transition: "border-color 0.2s"
                              }}
                            />
                            {this.state.approvalNotesError && (
                              <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "6px" }}>
                                {this.state.approvalNotesError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          {this.state.approve_client_button ? (
                            <button
                              className="btn btn-lg btn-primary"
                              type="button"
                              disabled
                            >
                              <span
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span> Processing... </span>
                            </button>
                          ) : (
                            <>
                              <a
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-dim btn-outline-light"
                                onClick={() => {
                                  this.modalHideAlll("modalApproveClientAlert");
                                }}
                              >
                                <em className="icon ni ni-cross-round"></em>{" "}
                                <span>Cancel</span>
                              </a>
                              {"  "}
                              <a
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-mw btn-primary"
                                onClick={() => {
                                  this.approve_client_form();
                                }}
                                disabled={
                                  this.state.disabled || this.state.isProcessing
                                } // disable button when processing
                              >
                                <em className="icon ni ni-done"></em>{" "}
                                <span>Approve</span>
                              </a>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END APPROVE CLIENT MODAL  */}
              {/* START REJECTION CLIENT MODAL */}
              <div
                className="modal fade"
                tabindex="-1"
                id="modalRejectionClientAlert"
              >
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {this.state.rejection_client_title}{" "}
                        <sup className="text-primary">
                          {this.state.form_title}
                        </sup>
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.rejectClientErrorMessage !== "" ? (
                        <div className="alert alert-pro alert-danger mb-2">
                          <div className="alert-text">
                            <h6>Error</h6>
                            <p>{this.state.rejectClientErrorMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      {this.state.rejectClientSuccessMessage !== "" ? (
                        <div className="alert alert-pro alert-success mb-2">
                          <div className="alert-text">
                            <h6>Success</h6>
                            <p>{this.state.rejectClientSuccessMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      <div id="revokeReasonItems">
                        <div className="tb-odr-id">Reason to reject</div>
                        <div className="card card-bordered card-preview mt-1">
                          <TextareaAutosize
                            maxrows={4}
                            name="reject_client_reason"
                            id="reject_client_reason"
                            aria-label=""
                            placeholder=""
                            value={this.state.reject_client_reason}
                            helperText="Reason to reject this submission"
                            onChange={this.handleChange}
                            style={{
                              width: "100%",
                              height: "100px",
                              borderColor: "rgba(0, 0, 0, 0.125)",
                              borderRadius: "4px",
                            }}
                            variant="outlined"
                          />
                        </div>
                        <div className="form-group text-right mt-2 mb-2">
                          {this.state.reject_client_button === true ? (
                            <button
                              className="btn btn-primary"
                              type="button"
                              disabled
                            >
                              <span
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span> Loading... </span>
                            </button>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="btn btn-light"
                                onClick={() => {
                                  this.closeModal("modalRejectionClientAlert");
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <em className="icon ni ni-cross-round"></em>{" "}
                                <span>Cancel</span>
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                  this.reject_client_form();
                                }}
                                disabled={this.state.disabled}
                              >
                                <em className="icon ni ni-cross-circle"></em>{" "}
                                <span>Reject</span>
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END REJECTION CLIENT MODAL */}
              {/* START CLIENT REJECTIONS MODAL */}
              <div className="modal fade" tabindex="-1" id="modalRejectionClients">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        All Rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.rejectClientErrorMessage !== "" ? (
                        <div className="alert alert-pro alert-danger mb-2">
                          <div className="alert-text">
                            <h6>Error</h6>
                            <p>{this.state.rejectClientErrorMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      {this.state.rejectClientSuccessMessage !== "" ? (
                        <div className="alert alert-pro alert-success mb-2">
                          <div className="alert-text">
                            <h6>Success</h6>
                            <p>{this.state.rejectClientSuccessMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      <div id="revokeReasonItems">
                        {this.state.rejectionLoader === true ? (
                          FormLoader()
                        ) : (
                          <>
                            <div>
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  {this.state.allClientRejectionsListing &&
                                  this.state.allClientRejectionsListing.length >
                                    0 ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          All Rejections
                                        </h6>
                                      </div>
                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <table className="table table-bordered table-striped">
                                          <thead>
                                            <th>Form Title</th>
                                            <th>Rejection date</th>
                                            <th>Reason</th>
                                            <th>Submitted PDF</th>
                                          </thead>
                                          {this.state.allClientRejectionsListing.map(
                                            (general, index) => (
                                              <tbody
                                                key={`ind${index}`}
                                                className="text-dark"
                                              >
                                                <tr>
                                                  <td>
                                                    {this.state.form_title}
                                                  </td>
                                                  <td>
                                                    {this.format_date(
                                                      general.rejection_date,
                                                    )}
                                                  </td>
                                                  <td>
                                                    {general.rejection_reason}
                                                  </td>
                                                  <td>
                                                    {general.is_submitted &&
                                                    general.is_submitted ===
                                                      1 ? (
                                                      <a
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          this.downloadPdf(
                                                            general.pdf_name,
                                                          )
                                                        }
                                                      >
                                                        <span className="badge badge-outline-dark">
                                                          View
                                                        </span>
                                                      </a>
                                                    ) : (
                                                      "---"
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            ),
                                          )}
                                        </table>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>No Rejection</h6>
                                        <p>
                                          Rejections are not available against
                                          this submission.
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END REJECTIONS CLIENT MODAL */}
              {/* START DELETE MODAL  */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalDeleteGeneralAlert"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideDel();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                        <h4 className="nk-modal-title">Delete Submission?</h4>

                        <div className="nk-modal-text">
                          {this.state.errorMessageDelete !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageDelete}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageDelte !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageDelte}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="caption-text">
                            Are you sure you want to delete this submission
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideDelGeneral();
                            }}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.deleteGeneralSubmission();
                            }}
                            disabled={
                              this.state.disabled || this.state.isProcessing
                            } // disable button when processing
                          >
                            {this.state.isProcessing ? (
                              <span>DELETING...</span>
                            ) : (
                              <span>DELETE</span>
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END DELETE MODAL  */}
              {/* START RESEND MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalResendAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closeResendForm()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-emails bg-success"></em>

                        <h4 className="nk-modal-title">Resend Form?</h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessageResend !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageResend}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageResend !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageResend}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="caption-text">
                            Are you sure you want to resend this form?
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          {this.state.resendLoader === true ? (
                            <button
                              className="btn btn-lg btn-primary"
                              type="button"
                              disabled
                            >
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span> Sending... </span>
                            </button>
                          ) : (
                            <>
                              <a
                                className="btn btn-lg btn-light"
                                style={{ cursor: "pointer", color: "#101924" }}
                                onClick={() => this.closeResendForm()}
                              >
                                CANCEL
                              </a>
                              {"  "}
                              <a
                                style={{ cursor: "pointer" }}
                                className={"btn btn-lg btn-mw btn-primary"}
                                onClick={() => {
                                  this.resendGeneralForm();
                                }}
                                disabled={this.state.disabled ? true : false}
                              >
                                Resend
                              </a>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END RESEND MODAL  */}
              {/* START DELETE MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideDel();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>

                        <h4 className="nk-modal-title">Delete Submission?</h4>

                        <div className="nk-modal-text">
                          {this.state.errorMessageDelete !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageDelete}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageDelte !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageDelte}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="caption-text">
                            Are you sure you want to delete this submission
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.deleteSubmission();
                            }}
                            disabled={this.state.deleteLoader} // disable button when processing
                          >
                            {this.state.deleteLoader ? (
                              <span>DELETING...</span>
                            ) : (
                              <span>DELETE</span>
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END DELETE MODAL  */}
              {/* View Client Submissions */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalClientArchivedSubmission"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> Archived
                          Submission Details{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.viewLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                <div className="card-inner">
                                  <div className="sp-plan-head">
                                    <h6 className="title">
                                      Form Submission Details
                                    </h6>
                                  </div>

                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                    <table className="table table-bordered table-striped">
                                      <tbody key="arch1" className="text-dark">
                                        <tr>
                                          <td>Form Title</td>
                                          <td>{this.state.form_title}</td>
                                        </tr>
                                        <tr>
                                          <td>Archive Date</td>
                                          <td>
                                            {this.state.archive_date &&
                                            this.state.archive_date !== ""
                                              ? this.format_date(
                                                  this.state.archive_date,
                                                )
                                              : "---"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Archive Reason</td>
                                          <td>
                                            {this.state.archive_reason &&
                                            this.state.archive_reason !== ""
                                              ? this.state.archive_reason
                                              : "---"}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View Client Submissions */}
              {/* get Submission Link */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalSubmissionLink"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-copy"></em> Submission
                          Link{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {this.state.deleteLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                <div className="card-inner">
                                  <div className="sp-plan-head">
                                    <h6 className="title">
                                      Copy Submission link
                                    </h6>
                                  </div>
                                  {this.state.successMessageSub !== "" ? (
                                    <div
                                      className="example-alert "
                                      style={{
                                        marginBottom: "20px",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {this.state.successMessageSub && (
                                        <div className="alert alert-success mb-3">
                                          <strong>Success:</strong>{" "}
                                          {this.state.successMessageSub}
                                        </div>
                                      )}
                                    </div>
                                  ) : null}

                                  <div className="sp-plan-desc sp-plan-desc-mb d-flex align-items-center justify-content-between">
                                    <p
                                      style={{
                                        marginBottom: "0",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      <a
                                        href={this.state.submission_link}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {this.state.submission_link}
                                      </a>
                                    </p>
                                    <div className="d-flex align-items-center ml-3">
                                      {/* Copy Icon */}
                                      <a
                                        onClick={this.copySubmissionLink}
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px",
                                        }}
                                      >
                                        {this.state.copiedSub ? (
                                          <em
                                            className="icon ni ni-check"
                                            style={{ fontSize: "18px" }}
                                          ></em>
                                        ) : (
                                          <em
                                            className="icon ni ni-copy"
                                            style={{ fontSize: "18px" }}
                                          ></em>
                                        )}
                                      </a>

                                      {/* Mail Icon */}
                                      <a
                                        onClick={() =>
                                          this.setState({
                                            showMailForm:
                                              !this.state.showMailForm,
                                          })
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className="icon ni ni-mail"
                                          style={{ fontSize: "18px" }}
                                        ></em>
                                      </a>
                                    </div>
                                  </div>

                                  {/* Inline Mail Form */}
                                  {this.state.showMailForm && (
                                    <div className="mt-4">
                                      {this.state.errorMessageMail !== "" ? (
                                        <div
                                          className="example-alert"
                                          style={{ marginBottom: "15px" }}
                                        >
                                          <div className="alert alert-pro alert-danger">
                                            <div className="alert-text">
                                              <h4>Error</h4>
                                              <p>
                                                {this.state.errorMessageMail}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      {this.state.successMessageMail !== "" ? (
                                        <div
                                          className="example-alert"
                                          style={{ marginBottom: "15px" }}
                                        >
                                          <div className="alert alert-pro alert-success">
                                            <div className="alert-text">
                                              <h4>Success</h4>
                                              <p>
                                                {this.state.successMessageMail}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}

                                      <div className="form-group">
                                        <label>
                                          Name{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={this.state.mailName}
                                          onChange={(e) =>
                                            this.setState({
                                              mailName: e.target.value,
                                            })
                                          }
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label>
                                          Email{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="email"
                                          className="form-control"
                                          value={this.state.mailEmail}
                                          onChange={(e) =>
                                            this.setState({
                                              mailEmail: e.target.value,
                                            })
                                          }
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label>
                                          Comment{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <textarea
                                          className="form-control"
                                          value={this.state.mailComment}
                                          onChange={(e) =>
                                            this.setState({
                                              mailComment: e.target.value,
                                            })
                                          }
                                        />
                                      </div>

                                      <button
                                        className="btn btn-primary"
                                        onClick={this.sendSubmissionLinkByEmail}
                                      >
                                        Send Link
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View Client Submissions */}
              {/* NOTIFICATION MODAL */}
              <div
                className="modal fade"
                tabindex="-1"
                id="modalNotificationSchedule"
              >
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-bell"></em>{" "}
                        <span>
                          Schedule Notifications of{" "} <small className='text-muted'>- {this.state.user_details}</small>
                        </span>
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.notificationErrorMsg !== "" ? (
                        <div className="alert alert-pro alert-danger mb-3">
                          <div className="alert-text">
                            <h6>Missing Fields</h6>
                            <p>{this.state.notificationErrorMsg} </p>
                          </div>
                        </div>
                      ) : null}
                      {this.state.notificationSuccessMsg !== "" ? (
                        <div className="alert alert-pro alert-success mb-3">
                          <div className="alert-text">
                            <h6>Success</h6>
                            <p>{this.state.notificationSuccessMsg} </p>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-md-12 mb-4">
                        <div className="custom-control custom-control-lg custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="notification_scheduler"
                            onChange={this.handleNotificationSchedule}
                            value={this.state.notification_scheduler}
                            checked={this.state.notification_scheduler}
                          autoComplete="new-password" />
                          <label
                            className="custom-control-label"
                            for="notification_scheduler"
                          >
                            Enable Notification Scheduler
                          </label>
                        </div>
                      </div>
                      {this.state.schedule_div === true ? (
                        <div className="row g-4 mb-4">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label
                                className="form-label"
                                for="initial_reminder_interval"
                              >
                                Initial Reminder (Hours)
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="initial_reminder_interval"
                                  name="initial_reminder_interval"
                                  placeholder="Allowed values between 1 to 24"
                                  onChange={this.handleChangeInitialReminder}
                                  value={this.state.initial_reminder_interval}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                              <div className="form-note"></div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label" for="repeat_interval">
                                Repeat Reminder (Hours)
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="repeat_interval"
                                  name="repeat_interval"
                                  placeholder="Allowed values between 1 to 48"
                                  value={this.state.repeat_interval}
                                  onChange={this.handleChangeRepeatReminder}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label" for="repeat_count">
                                Maximum Days
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="repeat_count"
                                  name="repeat_count"
                                  placeholder="Allowed values between 1 to 12 days"
                                  value={this.state.repeat_count}
                                  onChange={this.handleChangeRepeatDays}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group text-right">
                              {this.state.notification_loader === true ? (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled
                                >
                                  <span
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span> Saving... </span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.submitNotifications()}
                                  className="btn btn-primary"
                                >
                                  Submit
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              {/* NOTIFICATION MODAL */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Forms);
